const de = {
  global: {
    my_resume: 'Mein Lebenslauf',
    resume: 'Lebenslauf',
    ok: 'OK',
    or: 'oder',
    and: 'und',
    step: 'Schritt',
    yes: 'Ja',
    no: 'Nein',
    employment: 'Beschäftigung',
    from: 'Von',
    to: 'Bis',
    start: 'Beginn',
    end: 'Ende',
    new: 'Neu',
    more_info: 'Weitere Infos',
    trade: 'Gewerbe',
    experience: 'Erfahrung',
    place: 'Ort',
    suggested: 'Vorgeschlagen',
    titles: {
      all_done: 'Fertig',
      fill_out_form: 'Formular ausfüllen',
      sent: 'Gesendet',
      added: 'Hinzugefügt',
      saved: 'Gespeichert',
      welcome: 'Ihre Registrierung war erfolgreich! Willkommen bei Koderia',
    },
    actions: {
      create_resume: 'Erstellen',
      save: 'Speichern',
      recommend: 'Empfehlen',
      share: 'Teilen',
      upload_file: 'DATEI HOCHLADEN',
      send: 'Senden',
      continue: 'Weiter',
      back: 'Zurück',
      select: 'Auswählen',
      delete: 'Löschen',
      delete_account: 'Konto löschen',
      add_post: 'Beitrag hinzufügen',
      open: 'ÖFFNEN',
      upload_files: 'DATEIEN HOCHLADEN',
      IMPORT: 'IMPORTIEREN',
      add_more: 'Weitere hinzufügen',
      add: 'Hinzufügen',
      add_another: 'Weitere hinzufügen',
      copy: 'Kopieren',
      complete: 'Beenden',
      resend: 'Erneut senden',
      show_less: 'Weniger anzeigen',
      unlock: 'Entsperren',
      change_image: 'Bild ändern',
      change_logo: 'Logo ändern',
      publish: 'Veröffentlichen',
      back_to_home_page: 'Zurück zur Hauptseite',
      edit: 'Bearbeiten',
      download: 'Herunterladen',
      close: 'Schließen',
      register: 'Registrieren',
      confirm: 'Bestätigen',
      more: 'Mehr',
    },
    time: {
      monthly: 'Monatlich | Monatlich',
      annual: 'Jährlich',
      today: 'Heute',
      hour: 'Std',
      year: 'Jahr',
      years: 'Jahr | Jahre | Jahre',
      month: 'Monat',
      months: 'Monat | Monate | Monate',
      several_weeks: 'in ein paar Wochen',
      months_3: '3 Monate',
      months_6: '6 Monate',
      manday: 'Personentag',
      now: 'jetzt',
      later: 'später',
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember',
    },
    errors: {
      unknown: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
      already_exists: 'Die E-Mail-Adresse wird bereits von einem anderen Konto verwendet.',
      auth_expired_action_code: 'Der Token ist abgelaufen.',
      auth_invalid_action_code: 'Ungültiger Token.',
      auth_user_disabled: 'Konto wurde gesperrt.',
      auth_user_not_found: 'Ungültige Anmeldeinformationen.',
      auth_weak_password: 'Das Passwort ist nicht sicher genug.',
      auth_email_already_in_use: 'Die E-Mail-Adresse wird bereits von einem anderen Konto verwendet.',
      auth_invalid_email: 'Ungültige E-Mail.',
      auth_operation_not_allowed: 'Der Vorgang ist nicht zulässig.',
      auth_account_exists_with_different_credential: 'Konto existiert bereits mit anderen Anmeldeinformationen.',
      auth_invalid_credential: 'Ungültige Anmeldeinformationen.',
      auth_wrong_password: 'Ungültiges Passwort.',
      auth_invalid_phone_number: 'Ungültige Telefonnummer.',
      auth_missing_phone_number: 'Telefonnummer fehlt.',
      auth_cancelled_popup_request: 'Das Popup wurde geschlossen.',
      auth_popup_blocked: 'Das Popup wurde blockiert.',
      auth_popup_closed_by_user: 'Das Popup wurde geschlossen, bevor der Vorgang abgeschlossen wurde.',
      auth_user_token_expired: 'Token ist abgelaufen.',
      auth_invalid_api_key: 'Ungültiger API-Schlüssel.',
      auth_network_request_failed: 'Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
      auth_requires_recent_login: 'Aktueller Login erforderlich.',
      auth_too_many_requests: 'Zu viele Anfragen in kurzer Zeit.',
      auth_invalid_password: 'Ungültiges Passwort.',
      auth_email_already_exists: 'Die E-Mail-Adresse wird bereits verwendet.',
      auth_phone_number_already_exists: 'Die Telefonnummer wird bereits verwendet.',
      auth_insufficient_permission: 'Sie verfügen nicht über ausreichende Berechtigungen.',
      auth_internal: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
      auth_social_login_provider: 'Diese E-Mail-Adresse ist mit einem Social-Media-Login (z. B. Google) verknüpft. Bitte melden Sie sich mit Ihrem Social-Media-Konto an oder versuchen Sie es mit einer anderen E-Mail-Adresse.',
      permission_denied: 'Sie verfügen nicht über ausreichende Berechtigungen.',
      phone_codes_error: 'Beim Abrufen der Ländervorwahlen ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut.',
      unexpected_error: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
      error_404: 'Beim Abrufen der Daten für „{name}“ ist ein Problem aufgetreten. Bitte versuchen Sie es später noch einmal.',
      job_application_unavailable: 'Eine Bewerbung auf diese Stelle ist derzeit nicht möglich.',
    },
    inputs: {
      examples: {
        name: 'John',
        email: 'john.dear@gmail.com',
        searchJob: 'Suche nach Frontend, Linux, SQL...',
      },
      firstname_surname: 'Vor- und Nachname',
      email: 'E-Mail',
      first_name: 'Vorname',
      last_name: 'Nachname',
      password: 'Passwort',
      city: 'Stadt',
      experiences: 'Erfahrungen',
      phone: 'Telefon',
      profession: 'Beruf',
      technology: 'Technologien',
      name: 'Bezeichnung',
      company: 'Firma',
      position: 'Position',
      title: 'Titel',
      search_expertise: 'Suchtechnologie',
    },
    form_rules: {
      length_6: '6 oder mehr Zeichen',
      non_empty_field: 'Bitte füllen Sie dieses Feld aus',
      valid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      phone_number: 'Die Telefonnummer muss das Format +421 9XX XXX XXX haben',
      min_3: 'Mindestens 3',
      not_valid_email: 'E-Mail muss eine gültige E-Mail-Adresse sein.',
      password_length: 'Das Passwort muss mindestens 6 Zeichen enthalten.',
      min_1_technology: 'Bitte geben Sie mindestens 1 Technologie ein.',
      event_image_required: 'Ein Bild des Events ist erforderlich.',
      event_name_required: 'Die Bezeichnung des Events ist erforderlich.',
      event_name_min_3_characters: 'Die Bezeichnung des Events muss mindestens 3 Zeichen lang sein.',
      event_datetime_manadatory: 'Datum und Uhrzeit des Events sind obligatorisch.',
      link_format: 'Der Link hat nicht das richtige Format (Beispiel: https://koderia.sk/podujatia).',
      event_reference_required: 'Ein Link zur Veranstaltung ist obligatorisch.',
      venue_required: 'Der Veranstaltungsort ist obligatorisch.',
      event_description_required: 'Eine Beschreibung der Veranstaltung ist erforderlich.',
      organizer_logo_required: 'Veranstalterlogo ist erforderlich.',
      organizer_name_required: 'Veranstaltername ist erforderlich.',
      organizer_website_required: 'Website des Veranstalters ist obligatorisch.',
      organizer_description_required: 'Die Beschreibung des Veranstalters ist obligatorisch.',
      organizer_description_long: 'Die Veranstalterbeschreibung ist zu lang.',
      event_end_before_start: 'Das Ende der Veranstaltung darf nicht vor ihrem Beginn liegen',
      required_field: 'Pflichtfeld',
      first_name_filled: 'Vorname muss ausgefüllt werden.',
      last_name_filled: 'Nachname muss ausgefüllt werden.',
      password_min_six_characters: 'Das Passwort muss mindestens 6 Zeichen enthalten.',
      accept_terms_conditions: 'Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren.',
      no_data: 'Keine Daten verfügbar.',
    },
    form_errors: {
      check_entered_information: 'Ein Fehler ist aufgetreten. Überprüfen Sie die eingegebenen Informationen.',
      upload_photo_max_size_5mb: 'Das Foto konnte nicht hochgeladen werden, die maximale Größe beträgt 5 MB.',
      enter_name: 'Bitte geben Sie Ihren Vornamen ein.',
      enter_last_name: 'Bitte geben Sie Ihren Nachnamen ein.',
      enter_email: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
      select_phone_code: 'Bitte wählen Sie die Telefonvorwahl Ihres Landes aus.',
      enter_phone_number: 'Bitte geben Sie Ihre Telefonnummer ein.',
      valid_phone_number: 'Bitte geben Sie eine gültige Telefonnummer ein.',
      forgot_profession: 'Haben Sie vergessen, Ihren Beruf anzugeben?',
      select_available_from_date: 'Bitte wählen Sie ein Verfügbarkeitsdatum aus.',
      no_data_available: 'Keine Daten verfügbar',
      select_utm_source: 'Bitte wählen Sie aus, wie Sie von uns erfahren haben.',
      select_non_it_registration_reason: 'Bitte wählen Sie Ihren Registrierungsgrund aus.',
    },
    deprecated: {
      agree_with_processing_personal_data_according_to_current_working: 'Ich stimme der Verarbeitung personenbezogener Daten gemäß der aktuellen Fassung zu',
      privacy_policy_small: 'Datenschutzrichtlinie',
      confirm_that_koderia_contact_me_in_future: 'Ich bestätige, dass Koderia mich in Zukunft kontaktieren kann',
    },
    expertiseTypes: {
      PROGRAMMING_LANGUAGE: 'Programmiersprache',
      FRAMEWORK: 'Framework',
      DATABASE: 'Datenbank',
      LIBRARY: 'Bibliothek',
      LIBRARY_OR_FRAMEWORK: 'Bibliothek / Framework',
      CLOUD: 'Cloud',
      TOOLS: 'Tools',
      PLATFORM_OR_TOOL: 'Plattform / Tool',
      METHODOLOGY: 'Methodik',
      DEVOPS: 'Dev / Ops',
      OTHER: 'Andere',
    },
    expertiseLevel: {
      '0-1': 'Weniger als 1 Jahr',
      1: '1 Jahr',
      2: '2 Jahre',
      3: '3 Jahre',
      4: '4 Jahre',
      '5-10': '5 – 10 Jahre',
      '10+': 'Mehr als 10 Jahre',
    },
    utm_source: {
      referral: 'Empfehlung',
    },
    non_it_registration_reasons: {
      student: 'Ich studiere Informatik und möchte in Zukunft IT-Spezialist werden',
      no_contact: 'Ich bin ein IT-Fachmann, möchte aber nicht, dass Sie mich mit Stellenangeboten kontaktieren',
      try_tools: 'Ich möchte nur Koderia-Tools ausprobieren (z. B. Gehaltsrechner, Mein Lebenslauf)',
    },
  },
  ad: {
    not_interested_in_any_position: 'Hat Sie keine Stelle interessiert? Sagen Sie uns, was das ideale Projekt erfüllen muss, und wir finden es.',
    do_you_know_anyone_might_be_interested_in_this_position: 'Kennen Sie jemanden, der an dieser Stelle interessiert sein könnte? Empfehlen Sie ihn/sie weiter und erhalten Sie eine Provision',
    every_day: 'täglich',
    you_can_also_have_commission_from_this_position: 'Auch aus dieser Position können Sie eine Provision erhalten',
    do_you_know_anyone_might_be_interested_in_position: 'Kennen Sie jemanden, der an diesen Positionen interessiert sein könnte? Empfehlen Sie ihn/sie weiter und erhalten Sie eine Provision',
  },
  auth: {
    titles: {
      create_account: 'Konto erstellen',
      account: 'Konto',
    },
    subTitles: {
      account_advantages: 'Genießen Sie alle Vorteile eines Koderia-Kontos kostenlos',
      verification: 'Kontobestätigung erforderlich',
    },
    actions: {
      sign_up_simple: 'Registrieren',
      sign_in_simple: 'Anmelden',
      sign_in: 'Anmelden',
      sign_up: 'Registrieren',
      logout: 'Abmelden',
      create_new_account: 'Neues Konto erstellen.',
      create_account: 'Konto erstellen',
      forgot_password: 'Passwort vergessen',
      sign_in_here: 'Hier anmelden.',
      sign_up_here: 'Registrieren',
      verify: 'Bestätigung senden',
    },
    descriptions: {
      check_email: 'Überprüfen Sie Ihr E-Mail-Postfach, zur Sicherheit auch den Spam-Ordner. Wenn Sie sich nicht anmelden können, schreiben Sie uns an.',
      dont_have_account: 'Sie haben noch kein Konto?',
      email_associated_with_koderia: 'Wenn die angegebene E-Mail-Adresse mit einem Konto bei Koderia verknüpft ist, senden wir ihr einen Link zum Zurücksetzen des Passworts.',
      check_confirmation_email: 'Bitte überprüfen Sie Ihr E-Mail-Postfach, an das wir Ihnen eine Bestätigungs-E-Mail gesendet haben.',
      check_welcome_email: 'Bitte überprüfen Sie Ihr E-Mail-Postfach, an das wir Ihnen eine Willkommens-E-Mail gesendet haben.',
      already_have_account: 'Sie haben bereits ein Konto?',
      advantage_1: 'Zugriff auf wertvolle Koderia-Dienste',
      advantage_1_message: 'Bevorzugte Dienste, angemessenes Gehalt, Gehaltsrechner oder Koderia Extra an einem Ort   (?)',
      advantage_2: 'Einfache Antwort auf IT-Projekte',
      advantage_2_message: 'Dank der vorausgefüllten Formulare können Sie mit nur einem Klick auf Koderia-IT-Projekte und -Dienste antworten',
      advantage_3: 'Personalisierte Stellenangebote',
      advantage_3_message: 'Auf Ihre Spezialisierung zugeschnittene und sortierte Stellenangebote',
      advantage_4: 'Transparente Zusammenarbeit',
      advantage_4_message: 'Eine Übersicht über Ihre Daten und genutzten Dienste, auf die Sie jederzeit zurückgreifen oder die Sie ändern können',
      verification_dialog_message: 'Bitte bestätigen Sie Ihre E-Mail-Adresse, um auf diesen Abschnitt zuzugreifen. Wir haben einen Bestätigungslink an Ihre registrierte E-Mail gesendet. Klicken Sie auf den Link in der E-Mail, um fortzufahren. Wenn du die E-Mail nicht erhalten hast, prüfe bitte deinen Spam-Ordner oder fordere eine neue Bestätigungs-E-Mail an.',
      non_it_description: 'Wenn Sie die Option wählen, dass Sie nicht aus dem IT-Bereich kommen, werden wir Sie nicht kontaktieren oder Ihnen die Mitarbeit an Projekten anbieten. Wenn Sie sich jedoch dazu entschließen, Ihren Schwerpunkt in Zukunft zu ändern, können Sie ihn jederzeit in Ihrem Profil bearbeiten. Wenn Sie einfach den falschen Beruf gewählt haben oder nicht wissen, wie Sie sich einordnen sollen, wählen Sie bitte die Option ANDERE.',
    },
    inputs: {
      remember_login: 'Login merken',
    },
  },
  cookie: {
    description: 'Die Website Koderia.sk verwendet Cookies, um Dienste bereitzustellen und den Datenverkehr zu analysieren. Indem Sie weiter surfen, stimmen Sie deren Verwendung zu.',
    more_information: 'Weitere Informationen.',
    button: 'Ich verstehe und stimme zu',
  },
  navigation: {
    titles: {
      job_offer: 'Stellenangebote',
      legal_information: 'Rechtliche Informationen',
      social_network: 'Soziale Netzwerke',
      it_specialists: 'Für IT-Spezialisten',
      companies: 'Für Unternehmen',
      menu: 'Menü',
      next: 'Weiter',
    },
    home: 'Home',
    jobs: 'IT-Projekte',
    companies: 'Für Unternehmen',
    specialists: 'Für IT-Spezialisten',
    carrier: 'Karriere',
    events: 'Events',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Wörterbuch',
    what_is_koderia: 'Was ist Koderia?',
    adequate_salary: 'Angemessenes Gehalt',
    calculator: 'Gehaltsrechner',
    work_comparison: 'Arbeitsvergleich',
    work_types_comparison: 'Vergleich der Arbeitsformen',
    koderia_referral: 'Koderia-Empfehlung',
    koderia_extra: 'Koderia Extra',
    privacy_policy: 'Datenschutzrichtlinie',
    resume: 'Lebenslauf',
    create_resume: 'Lebenslauf erstellen',
    terms_conditions: 'Allgemeine Geschäftsbedingungen',
    koderia_dictionary: 'Koderia-Wörterbuch',
    about_us: 'Über uns',
    contact_us: 'Kontakt',
    policy: 'Richtlinien',
    settings: 'Einstellungen',
    create_new_koderia_biography: 'Neuen Koderia-Lebenslauf erstellen',
    company_services: 'Dienstleistungen',
    company_cases: 'Fallstudien',
  },
  homepage: {
    home: 'Homepage',
    subtitles: {
      blogs: 'Neueste Blogs',
      career_it: 'Karriere für IT-Spezialisten',
      company_solutions: 'IT-Lösungen für Unternehmen',
      cv_feature: 'Moderne und übersichtliche Lebensläufe. <br /> Für alle in der IT. <br /> Kostenlos.',
      adequate_salary_feature: 'Angemessenes Gehalt',
      salary_calculator_feature: 'Gehaltsrechner',
      they_said: 'Das sagt man über uns',
      our_projects: 'Unsere Projekte',
      companies_trust: 'Führende Unternehmen vertrauen uns',
      open_projects: 'Offene IT-Projekte',
      features: 'Für Sie erstellt. Kostenlos',
    },
    descriptions: {
      career_it: 'Wenn Sie echtes Wachstum in Ihrer IT-Karriere anstreben, sind Sie bei uns genau richtig. Unsere Plattform bietet Möglichkeiten, die Ihre Erwartungen übertreffen können. Probieren Sie etwas Neues aus und entdecken Sie, was Sie alles erreichen können.',
      company_solutions: 'Sie suchen IT-Spezialisten für Ihr Projekt oder eine maßgeschneiderte Lösung?',
      cv_feature: 'Erstellen Sie in nur wenigen Minuten einen ansprechenden Lebenslauf, <br /> den Sie jederzeit bearbeiten, weitergeben oder ausdrucken können.',
      adequate_salary_feature: 'Wie werden Ihre bisher erworbenen <br /> Fähigkeiten und Erfahrungen bewertet?',
      salary_calculator_feature: 'Sie arbeiten in einem unbefristeten <br /> Arbeitsverhältnis? Finden Sie heraus, wie viel <br /> Sie als Freiberufler oder in einer <br /> GmbH verdienen würden.',
    },
    actions: {
      show_all: 'Alles zeigen',
      show_projects: 'IT Projekte anzeigen',
      more_info: 'Mehr Infos',
    },
  },
  project: {
    title: 'Plant Ihr Kollege, Freund oder Bekannter einen Jobwechsel?',
    subtitles: {
      referral: 'Plant Ihr Kollege, Freund oder Bekannter einen Jobwechsel?',
      extra: 'Keine Stelle hat Sie interessiert??',
    },
    descriptions: {
      referral: 'Empfehlen Sie ihn für eines unserer Projekte und erhalten Sie im Erfolgsfall täglich eine Provision.',
      extra: 'Füllen Sie ein kurzes Formular aus und wir suchen für Sie ein <br class="tw-hidden md:tw-block" /> Projekt entsprechend Ihren ausgewählten Anforderungen.',
    },
    actions: {
      learn_more: 'Mehr erfahren',
      reset_filters: 'Filter zurücksetzen',
    },
    detail: {
      status: {
        not_available: 'Dieses Projekt ist bereits vergeben oder nicht aktuell.',
        new: 'Neu',
        remote: 'Remote',
        already_responded: 'Sie haben bereits auf dieses Angebot geantwortet',
      },
      subtitles: {
        position: 'Stellenbeschreibung',
        hr_need_info: 'Benötigen Sie weitere Informationen?',
        interest_contacts: 'Kontaktdaten und Lebenslauf',
        good_news: 'Gute Nachrichten',
        interest_upload_resume: 'Jetzt Lebenslauf hochladen?',
      },
      descriptions: {
        useful_for_you: 'Den Angaben in Ihrem Profil und Lebenslauf zufolge könnte dieser Job für Sie geeignet sein. Verpassen Sie nicht die Gelegenheit, an dem zu arbeiten, was zu Ihnen passt.',
        create_resume: 'Erstellen Sie einen Koderia-Lebenslauf und finden Sie heraus, wie Ihre Erfahrungen zu den Anforderungen für dieses Stellenangebot passen.',
        team_contacts_you: 'In den nächsten Tagen wird sich ein Mitglied unseres Teams mit Ihnen in Verbindung setzen und die weitere Vorgehensweise mit Ihnen abstimmen.',
        modern_resume: 'Ein moderner und übersichtlicher Lebenslauf für <br class="md:tw-hidden" /> alle in der IT.',
        hr_contact_directly: 'Kontaktieren Sie unsere Personalvermittler direkt, die Ihnen gerne mehr erzählen.',
        interest_team_contacts_you: 'Vielen Dank für Ihr Interesse, wir werden uns bald bei Ihnen melden.',
        interest_recommended_upload: 'Wir empfehlen, ihn jetzt hochzuladen, wir werden ihn brauchen.',
      },
      actions: {
        respond_to_offer: 'Auf das Angebot reagieren.',
        all_jobs: 'Alle Jobs',
      },
      salary: 'Gehalt',
      location: 'Standort',
      views: 'Ansicht | Ansichten | Ansichten',
      candidates: 'Kandidat | Kandidaten | Kandidaten',
      requirements: 'Anforderungen',
      employer_benefits: 'Arbeitgeberleistungen',
      project_duration: 'Projektdauer',
      duration_extension: 'mit Möglichkeit zur Verlängerung',
      start_date: 'Startdatum',
      type: 'Typ',
      tpp: 'TPP',
      contract: 'Vertrag',
      agreement: 'Vereinbarung',
      project_language: 'Sprache im Projekt',
      similar_job: 'Ähnliche Jobs',
      free: 'Kostenlos',
      salary_per_contract: 'Gehalt nach Vertrag',
      salary_per_tpp: 'Gehalt bei TPP',
      top_offer: 'Top-Angebot',
      email_reaction_to: 'Reaktion auf',
      email_body: 'Bitte vergessen Sie nicht, Ihren Lebenslauf anzuhängen',
    },
  },
  event: {
    title: 'Kommende Veranstaltungen',
    subtitles: {
      online: 'Online',
      slovakia_czech: 'Slowakei und Tschechien',
      event_info: 'Veranstaltungsinfo',
      organizer: 'Veranstalter',
    },
    descriptions: {
      upload_cover_image: 'Titelbild hochladen',
      basic_information: 'Grundlegende Informationen zur Veranstaltung wie Name, Ort, Beschreibung und Uhrzeit der Veranstaltung.',
      organizer_information: 'Veranstalterinformationen',
      no_scheduled_events: 'Derzeit sind keine Veranstaltungen geplant.',
    },
    detail: {
      action: 'Zum Kalender hinzufügen',
    },
    inputs: {
      event_link: 'Veranstaltungslink',
      list: 'Beschreibung',
      ticket_purchase_link_optional: 'Link zum Ticketkauf (optional)',
      webpage: 'Webseite',
      description_of_organizer: 'Beschreibung des Veranstalters',
      date_and_time: 'Datum und Uhrzeit',
    },
    cover_image: 'Titelbild',
    date_and_time: 'Datum und Uhrzeit',
    online_event: 'Online-Event',
    organize_question: 'Organisieren Sie ein Event?',
  },
  blog: {
    title: 'Koderia Blog',
    subtitles: {
      more_articles: 'Weitere Artikel',
    },
    description: 'Wir schreiben über Themen, die die IT-Welt bewegen',
    actions: {
      read: 'Lesen',
      more_articles: 'Weitere Artikel',
    },
    detail: {
      subtitle: 'Das könnte Sie interessieren',
    },
  },
  newsfeed: {
    title: 'Newsfeed',
    action: 'Weitere Artikel',
  },
  questionaire: {
    title: 'Angemessenes Gehalt',
    subtitles: {
      experience: 'Wie werden Ihre bisherigen<br class="tw-hidden lg:tw-block" /> Erfahrungen bewertet?',
      paid_jobs: 'Angemessen bezahlte Jobs',
      evaluate_resume: 'Lebenslauf auswerten',
      choose_method: 'Wählen Sie eine Bewertungsmethode',
      about_you: 'Informationen über Sie',
      master_technologies: 'Technologien, die Sie beherrschen',
      total_experience: 'Gesamtzahl der Jahre an Erfahrung',
      master_experience: 'Anzahl der Jahre an Erfahrung in',
      leadership_experience: 'Waren Sie schon einmal Teamleiter oder Scrum Master?',
      domain_experience: 'Haben Sie Erfahrung mit einem bestimmten Bereich?',
      domain_experience_examples: '(z. B. Bankwesen, Medizin, Telekommunikation, …)',
      software_architect_experience: 'Haben Sie als Softwarearchitekt gearbeitet?',
      type_of_tester: 'Welcher Testertyp sind Sie?',
      ci_experience: 'Haben Sie Erfahrung mit CI-Technologien wie Docker, Jenkins, GIT, …?',
      performance_experience: 'Haben Sie Erfahrung mit Performance-Test-Programmierung?',
      job_listing_title: 'Stellenliste',
    },
    descriptions: {
      salary_evaluate: 'Wir berechnen Ihr Gehalt auf Grundlage der Erfahrungen, die Sie in Ihrer Karriere gesammelt haben. Die Berechnung erfolgt durch Hochladen Ihres Lebenslaufs oder Ausfüllen des Formulars. Beide Optionen sind sehr genau.',
      experience_evaluate_by_team: 'Ihre Erfahrungen werden von einem Mitglied des Koderia-Teams bewertet.',
      experience_evaluate_by_system: 'Ihre Erfahrung wird von unserem ausgefeilten System bewertet.',
      experience_evaluate_by_pro_team: 'Ihre Erfahrung wird von einem Mitglied des Koderia PRO-Teams bewertet.',
      first_step: 'Im ersten Schritt ist es wichtig herauszufinden, welche Technologien Sie beherrschen und wie viele Jahre Erfahrung Sie haben.',
      second_step: 'Geben Sie im zweiten Schritt zusätzliche Informationen zu Ihrem bisherigen Werdegang an.',
      third_step: 'Hinterlassen Sie uns abschließend Ihren Namen und Ihre E-Mail-Adresse, an die wir das Ergebnis des Formulars senden.',
      answer_questions: 'Beantworten Sie die folgenden Fragen.',
      thank_you: 'Vielen Dank für Ihr Interesse, wir werden uns in Kürze bei Ihnen melden..',
    },
    actions: {
      all_jobs: 'Alle Jobs',
      upload_resume: 'Lebenslauf hochladen',
    },
    inputs: {
      choose_position: 'Wählen Sie eine Position',
    },
    programmer: 'Programmierer',
    tester: 'Tester',
    it_specialist: 'IT-Spezialist',
    project_manager: 'Projektmanager',
    analyst: 'Analyst',
    automated_tester: 'Automatisierter Tester',
    manual_tester: 'Manueller Tester',
  },
  calculator: {
    title: 'Gehaltsrechner',
    subtitles: {
      only_for_slovak: 'Gilt nur in der Slowakischen Republik',
      possible_earnings: 'Arbeiten Sie in einem unbefristeten Anstellungsverhältnis?<br class="tw-hidden lg:tw-block" />Finden Sie heraus, wie viel Sie in einem <b>Handelsunternehmen</b> oder einer <b>GmbH</b> verdienen würden.</b>',
      find_out_more: 'Erfahren Sie mehr.',
      billing_options: 'Abrechnungsoptionen',
      price_md: 'Preis pro Personentag',
      price_md_sup: 'Satz pro Personentag',
      recommended_job_offers: 'Stellenangebote für Sie',
    },
    actions: {
      calculate: 'Berechnen',
      find_job: 'Einen Job finden',
      get_hired: 'Eingestellt werden',
    },
    descriptions: {
      main: 'Das Gehaltsrechner-Tool berechnet den Betrag, den Sie in Rechnung stellen sollten, wenn Sie für ein Gewerbe oder eine GmbH aus dem TPP arbeiten, damit <b>die Kosten des Arbeitgebers nicht steigen.</b>',
      current_income: 'Ihr aktuelles Einkommen und Ihre Beiträge bei Festanstellung.',
      more_after_login: 'Nach dem Einloggen zeigen wir Ihnen gerne kostenlos mehr.',
      more_after_verify: 'Nach der Bestätigung Ihrer E-Mail zeigen wir Ihnen gerne kostenlos mehr.',
      your_md_rate: 'Wie hoch ist Ihr Personentagessatz?',
      earn_for_trade: 'Wie viel werden sie als Aufragnehmer mit Gewerbeschein verdienen?',
      earn_on_sro: 'Wie viel werden Sie verdienen, wenn Sie eine eigene GmbH haben?',
      fees_and_taxes: 'Welche Gebühren und Steuern werden Sie zahlen?',
      option_for_you: 'Welche Option lohnt sich für Sie mehr?',
      net_monthly_income: 'Dies ist der Betrag, den Sie erhalten sollten, wenn Sie eine Rechnung stellen.',
    },
    inputs: {
      gross_monthly_income: 'Geben Sie Ihr monatliches Bruttoeinkommen (mind. 700 €) ein',
    },
    taxes: 'Steuern',
    net_monthly_income: 'Monatliches Nettoeinkommen',
    months_worked_in_year: 'Arbeitsmonate im Jahr',
    super_gross_annual_salary: 'Super-Bruttojahresgehalt',
    employer_levies: 'Arbeitgeberabgaben',
    employee_contributions: 'Arbeitnehmerbeiträge',
    invoice_for_year: 'Abgerechnet pro Jahr',
    deductions_together: 'Abzüge zusammen',
    income_tax: 'Einkommensteuer',
    price_md: 'Preis pro Personentag',
    invoice_md: 'Der Betrag, den Sie für 1 Arbeitstag in Rechnung stellen sollten.',
    trade_first_year: 'Gewerbe im ersten Jahr',
    trade_2nd_and_next_year: 'Gewerbe im 2. und nächsten Jahr',
    average_net_monthly_income: 'Durchschnittliches monatliches Nettoeinkommen',
    taxes_and_levies: 'Steuern und Abgaben',
    health_insurance_contributions: 'Beiträge an die Krankenkasse',
    social_insurance_contributions: 'Zahlungen an die Sozialversicherungsbehörde',
    together: 'Zusammen',
    billing_options_learn_more: 'Erfahren Sie mehr über Rechnungsstellungsoptionen in',
    billing_options_learn_more_link: 'diesem Artikel.',
    company_sro: 'Gesellschaft (GmbH)',
    company_tax: 'Unternehmenssteuer',
    dividend_tax: 'Dividendensteuer',
    total_taxes: 'Gesamtsteuern',
    overview: 'Übersicht',
    price_of_labor: 'Arbeitspreis',
    super_gross_salary: 'Super-Bruttogehalt',
    gross_salary: 'Bruttogehalt',
    gross_salary_after_tax: 'Bruttogehalt nach Steuern',
    net_income: 'Nettoeinkommen',
    average_invoice: 'Durchschnittsrechnung',
    company_profit: 'Unternehmensgewinn',
    gross_tax_base: 'Bruttosteuerbemessungsgrundlage',
    flat_cost: 'Pauschalkosten',
    health_insurance: 'Krankenversicherung',
    social_insurance: 'Sozialversicherung',
    view_detailed_taxes_and_levies: 'Steuern und Abgaben im Detail anzeigen',
  },
  work_comparison: {
    title: 'Vergleich der Arbeitsformen',
    subtitle: 'Finden Sie heraus, welche der Arbeitsformen für Sie am besten geeignet ist',
    subheadings: {
      accounting: 'Buchhaltung',
      establishment: 'Niederlassung',
      taxes: 'Steuern',
      non_taxable_part: 'Nicht steuerpflichtiger Teil',
      levies: 'Abgaben',
    },
    descriptions: {
      main: 'Detaillierter Vergleich von Festanstellung, Gewerbe und GmbH.',
      taxes_follows_law: 'Aus dem Wortlaut des Gesetzes geht hervor, dass ab 2021 für Steuerzahler mit einem Umsatz von bis zu 49.790 EUR der Steuersatz von 15 % gilt.',
      annual_amount_non_taxable_part: 'Der jährliche Betrag des nicht steuerpflichtigen Teils der Steuerbemessungsgrundlage des Steuerzahlers beträgt im Jahr 2021 4.511,43 EUR, wenn die Steuerbemessungsgrundlage kleiner oder gleich 19.936,22 EUR ist. Ab diesem Betrag bis die Steuerbemessungsgrundlage den Betrag von 37.981,94 EUR übersteigt, verringert sich der nicht steuerpflichtige Teil auf Null.',
      social_insurance_not_paid: 'Sozialversicherung wird nicht gezahlt. Für  die Krankenversicherung wird das Minimum gezahlt. In den Folgejahren fallen Sozialversicherungsbeiträge an, wenn im Vorjahr die Einkommensgrenze von 6.078 € (für 2019) überschritten wurde, die Beiträge steigen zusammen mit dem Einkommen; man zahlt an die Krankenkasse, auch wenn man nichts verdient (die Mindestbeitragshöhe beträgt 70,91 € pro Monat).',
      manager_one_person: 'Wenn der Geschäftsführer eine Einzelperson ist und kein Gehalt bezieht, muss er keine Sozialversicherungsbeiträge zahlen und leistet die Krankenversicherungsbeiträge als Selbstzahler; wenn der Geschäftsführer jedoch auch Arbeitnehmer ist, muss er Beiträge sowohl an die Kranken- als auch an die Sozialversicherung zahlen.',
    },
    permanent_employment: 'Festanstellung',
    self_employed_person: 'Selbständiger',
    limited_liability_company: 'Gesellschaft mit beschränkter Haftung',
    simple: 'einfach',
    double: 'doppelt',
    income_tax: 'Einkommenssteuer',
    dividend_tax: 'Dividendensteuer',
    other: 'Sonstiges',
    holiday: 'Urlaub',
    sick_leave: 'Arbeitsunfähigkeit',
    retirement_savings: 'Altersvorsorge',
    low_contributions_low_pension: 'geringe Beiträge = niedrige Rente',
    benefits: 'Vorteile',
    disadvantages: 'Nachteile',
    regular_income: 'regelmäßiges Einkommen',
    financial_benefits: 'finanzielle und nichtfinanzielle Vorteile',
    get_loan: 'leichtere Kreditaufnahme',
    lower_salary: 'geringeres Gehalt',
    working_hours: 'genau festgelegte Arbeitszeiten',
    notice_period: 'Kündigungsfrist',
    fast_establishment_process: 'schneller und günstiger Gründungsprozess',
    possible_flat_rate_expenses: 'Möglichkeit der Nutzung pauschaler Ausgaben',
    social_contributions_exemption: 'Befreiung von Sozialversicherungsbeiträgen im 1. Jahr',
    unlimited_liability: 'unbeschränkte Haftung',
    health_social_contributions_amount: 'Kranken- und Sozialversicherungsbeiträge hängen von der Höhe des Einkommens ab',
    less_credible_image: 'weniger vertrauenswürdiges Image (für Geschäftspartner kann es den Eindruck eines Kleinunternehmers erwecken)',
    limited_liability: 'beschränkte Haftung',
    credible_image: 'besseres und vertrauenswürdigeres Image (erweckt bei Geschäftspartnern und potenziellen Mitarbeitern den Eindruck eines größeren und seriöseren Unternehmers)',
    equal_income_tax: 'pauschale Einkommenssteuer unabhängig vom erzielten Einkommen',
    expensive_founding_process: 'längerer und teurerer Gründungsprozess, einschließlich der Notwendigkeit, Gründungsdokumente zu erstellen',
    demanding_administration: 'anspruchsvollere und teurere Verwaltung (obligatorische doppelte Buchführung), 50-70 Euro/Monat',
    termination_process: 'komplizierterer Kündigungsprozess',
    graph_net_income: 'Graphischer Vergleich des Nettoeinkommens',
    company: 'Unternehmen',
    trade_after_first_year: 'Geschäft nach dem ersten Jahr',
    temporary_incapacity_for_work: 'vorübergehende Arbeitsunfähigkeit',
    gross_salary: 'Bruttogehalt (Rechnungsbetrag)',
    chart_popup_more_info: 'Genauere Daten finden Sie im Gehaltsrechner',
  },
  extra: {
    title: 'Extra',
    subtitles: {
      your_idea: 'Sagen Sie uns, wie Ihre <br class="tw-hidden lg:tw-block" />Arbeit aussehen soll',
      project_information: 'Projektinformationen',
      information_about_you: 'Informationen über Sie',
      preferred_technologies: 'Bevorzugte Technologien',
    },
    descriptions: {
      no_interested_position: 'Hat Sie keine Stelle interessiert? Füllen Sie ein kurzes Formular aus und wir suchen für Sie ein Projekt entsprechend den ausgewählten Anforderungen',
      will_be_in_touch: 'Vielen Dank, wir melden uns bald bei Ihnen. In der Zwischenzeit können Sie auf der Homepage sehen, was es Neues gibt.',
    },
    inputs: {
      date_of_start: 'Startdatum',
      phone_number_optional: 'Telefonnummer (optional)',
      question_or_additional_info: 'Fragen oder zusätzliche Informationen (optional)',
    },
    junior_less_than_2_years: 'Junior (weniger als 2 Jahre)',
    medior_2_4_years: 'Medior (2 - 4 Jahre)',
    senior_5_and_more: 'Senior (5 und mehr)',
  },
  referral: {
    title: 'Koderia-Empfehlung',
    subtitles: {
      colleague_planning: 'Plant Ihr Kollege, Freund <br class="tw-hidden lg:tw-block" />oder Bekannter einen Jobwechsel?',
      how_it_works: 'Wie funktioniert es?',
      forms_of_payment: 'Zahlungsarten',
      one_time_commission: 'einmalige Provision',
      worked_day: 'für jeden geleisteten Arbeitstag',
      ready_to_collaborate: 'Bereit zur Zusammenarbeit?',
      candidate_information: 'Kandidateninformationen',
      information_about_you: 'Informationen über Sie',
      you_should_know: 'Das sollten Sie wissen',
    },
    descriptions: {
      recommend_projects: 'Empfehlen Sie ihn für eines unserer Projekte und erhalten Sie im Erfolgsfall täglich eine Provision.',
      friend_looking: 'Ganz einfach. Sie erzählen uns von Ihrem Freund oder Kollegen, von dem Sie wissen, dass er einen Job in der IT sucht. Wir vermitteln ihn in eines unserer Projekte und die Provision gehört Ihnen.',
      fill_short_form: 'Füllen Sie ein kurzes Formular aus, auf dessen Grundlage wir Ihren Freund kontaktieren.',
      interview_with_you: 'Anschließend erfolgt ein Vorstellungsgespräch bei uns vor Ort oder beim Kunden, im Anschluss klären wir, ob wir zueinander gefunden haben.',
      concluding_contract: 'Vertragsabschluss mit dem erfolgreichen Kandidaten und Auszahlung der Provision.',
      one_time_commission: 'Wir zahlen eine einmalige Provision nach den ersten drei abgearbeiteten Monaten. Wir zahlen monatlich 5 € für jeden geleisteten Arbeitstag, vom Beginn bis zum Ende des Projekts. Für Projekte, die kürzer als 6 Monate sind, zahlen wir 500 € bzw. 5 € für jeden geleisteten Arbeitstag. Wir zahlen die Provision auch, wenn wir uns mit dem Kandidaten auf eine andere Position einigen.',
      recommendation_touch_soon: 'Vielen Dank für Ihre Empfehlung, wir melden uns bald bei Ihnen. In der Zwischenzeit können Sie auf der Homepage sehen, was es Neues gibt.',
      recommend_to_position: 'Empfehlen Sie einen Freund für eine bestimmte Position?',
      preferred_type_of_provision: 'Welche Art von Provision bevorzugen Sie? (Optional)',
      change_provision_type: 'Sie können die ausgewählte Vergütungsart jederzeit ändern.',
      forms_of_reward: 'Die Vergütungsformen sind: einmalige Provision in Höhe von <b>1000 €</b>, die wir nach den ersten drei Monaten der Arbeit auszahlen oder <b>5 € für jeden Arbeitstag</b>, vom Beginn bis zum Ende des Projekts (monatlich ausgezahlt).',
      shorter_projects: 'Für Projekte, die kürzer als 6 Monate sind, zahlen wir 500 € bzw. 5 € für jeden geleisteten Arbeitstag.',
      receive_commission: 'Sie erhalten die Provision auch, wenn wir uns mit dem Kandidaten auf eine andere Position einigen.',
      data_deleted_from_db: 'Ihre Daten werden aus unserer Datenbank gelöscht.',
      recommended_you: 'Er hat Sie für eine unserer offenen Stellen empfohlen. Wenn Sie die Person, die uns Ihre Informationen geschickt hat, nicht kennen, klicken Sie auf den untenstehenden Button und löschen Sie Ihre Daten.',
    },
    inputs: {
      current_position: 'Aktuelle Position',
    },
    one_time_1000: '1.000 € einmalig',
    per_day_worked_5: '5 € pro geleistetem Arbeitstag',
    record_not_found: 'Datensatz nicht gefunden.',
  },
  koderia_about: {
    title: 'Was ist Koderia?',
    descriptions: {
      unique_project: 'Koderia ist ein einzigartiges Projekt, bei dem alle Programmierer, IT-Enthusiasten, Studenten technischer Fächer sowie Menschen, die der IT-Welt nahe stehen, etwas finden, das ihnen gefällt. Informieren Sie sich unten über alles, was Koderia zu bieten hat.',
      homepage: 'Die Koderia-Homepage ist ein Sprungbrett zu allen Funktionen und Optionen, die wir anbieten. Sie finden die neuesten Stellenangebote, Beiträge von globalen Portalen, IT-Events in der Slowakei, aber auch online aus der ganzen Welt und vieles mehr.',
      job_section: 'Im Bereich „Jobs“ finden Sie die neuesten Stellenangebote. Wir vermitteln Arbeit in Unternehmen, die in ihrem Bereich führend sind, in der Slowakei, der Tschechischen Republik und Österreich. Wir haben bereits Dutzende von Programmierern und Programmiererinnen unter unseren Fittichen und unterstützen sie.',
      looking_for_colleague: 'Ihr Kollege, Freund oder Bekannter ist auf der Suche nach einem Job in der IT? Teilen Sie uns dies mit, und im Falle einer gegenseitigen Einigung und anschließenden Zusammenarbeit teilen wir die Provision mit Ihnen. Sie können 5 € pro Tag oder einen einmaligen Betrag von 1000 € verdienen.',
      interested_offer: 'Keines unserer Stellenangebote hat Sie interessiert? Über ein kurzes Formular auf unserer Website können Sie uns mitteilen, für welche Stelle Sie sich interessieren und wir kontaktieren Sie, wenn wir ein solches Angebot finden.',
      modern_resume: 'Ein moderner und übersichtlicher Lebenslauf, den Sie mit einem Klick teilen oder ausdrucken können, sollte heutzutage für jeden selbstverständlich sein, insbesondere im IT-Bereich.',
      salary_tool: 'Ein einfaches Tool, das anhand der Erfahrung die Höhe eines angemessenen Gehalts ermittelt.',
      trade_to_sro: 'Berechnung des Rechnungsbetrags beim Übergang von Vollzeitbeschäftigung zu Gewerbe oder GmbH.',
      blog: 'Der Blog hat eine eigene Seite. Darin schreiben wir über Themen, die in der IT-Welt Anklang finden, und über Ideen, mit denen wir uns identifizieren.',
    },
  },
  profile: {
    title: 'Koderia-Konto',
    subtitles: {
      email_settings: 'E-Mail-Einstellungen',
      invalid_link: 'Ungültiger Link',
      thank_you: 'Vielen Dank',
      linkedin_import_data: 'Daten von LinkedIn importieren',
      account_settings: 'Kontoeinstellungen',
      newsletter: 'Newsletter',
      basic_settings: 'Grundeinstellungen',
      delete_account: 'Möchten Sie Ihr Konto wirklich kündigen?',
      confirm_email_address: 'E-Mail-Adresse bestätigen',
      finish_signup: 'Bevor Sie beginnen, <br class="tw-hidden lg:tw-block" />erzählen Sie uns <br class="tw-hidden lg:tw-block" />etwas über sich.',
    },
    descriptions: {
      invalid_link: 'Der Link ist ungültig oder abgelaufen',
      recommended_salary: 'Dein Gehalt sollte nicht geringer sein als',
      find_out_recommended_salary: '<span>Füllen Sie den Abschnitt <a href="#" @click.prevent="$emit(\'go-to-experience\')" class="tw-text-black">Erfahrung</a> aus</span><br /><span>und finden Sie heraus, wie viel Sie verdienen sollten.</span>',
      approval_of_contribution: 'Wir informieren Sie über die Freigabe des Beitrags. Ihre hinzugefügten Beiträge finden Sie dann im Menü, im Abschnitt „Hinzugefügt“.',
      share_original_posts: 'Teilen Sie mit uns die Originalbeiträge, die Sie im Internet interessiert haben.',
      no_posts: 'Sie haben noch keine Beiträge hinzugefügt.',
      linkedin_open_personal_data: 'Öffnen Sie eine Unterseite über Ihre persönlichen Daten',
      linkedin_use_your_data: 'So verwendet LinkedIn Ihre Daten',
      linkedin_download_large_data: '<p class="step-info">Wählen Sie die Option <strong>Größeres Datenarchiv herunterladen…</strong></p>',
      linkedin_request_archive: '<p class="step-info">Klicken Sie dann auf <strong>Archiv anfordern</strong></p>',
      linkedin_unzip_file: 'Entpacken Sie die heruntergeladene Datei und laden Sie die Dateien bei uns hoch',
      linkedin_provide_file: 'Bitte beachten Sie, dass LinkedIn Ihnen die Datei möglicherweise nicht sofort zur Verfügung stellt.',
      import_click: 'Klicken Sie dann auf <strong>Importieren</strong>.',
      private_resume: 'Der Lebenslauf ist auf privat eingestellt. Sie können es ändern in',
      token_resume_no_password: 'Das Lebenslauf-Passwort ist nicht festgelegt. Sie können es festlegen in',
      private_resume_change: 'den Einstellungen, Abschnitt Datenschutz',
      what_is_experience_chart: 'Was stellt dieses Diagramm dar und wie funktioniert es?',
      fill_in_experience_chart: 'Fügen Sie zur korrekten Anzeige des Diagramms Ihre Erfahrung ein.',
      resume_link: 'Sie und die Personen, mit denen Sie Ihren Lebenslauf teilen, finden ihn unter diesem Link.',
      resume_language: 'Die Sprache, in der der Lebenslauf angezeigt wird.',
      resume_social_contact: 'Anzeige von E-Mail, Telefon und Website bzw. sozialem Netzwerk im Lebenslauf.',
      resume_availability: 'Wählen Sie aus, wem Sie Ihren Lebenslauf zur Verfügung stellen möchten.',
      account_password_not_allowed: 'Geben Sie nicht das Passwort Ihres Kontos ein!',
      resume_password_viewing_only: 'Dieses Passwort dient nur zum Anzeigen Ihres Lebenslaufs und ist nur für Personen verfügbar, denen Sie es geben möchten.',
      digital_experience_graph: 'Anzeige des Erfahrungsdiagramms in der digitalen Version des Lebenslaufs.',
      positions_based_on_technologies: 'Neue Stellen gemäß den Technologien, die Sie in Ihren Kontoeinstellungen angegeben haben.',
      sending_news: 'Alles Neue auf unserem Portal. Wir versenden es kontinuierlich – maximal 1x pro Monat.',
      new_blog_articles: 'Neue Artikel aus unserem Blog – maximal 1x pro Woche.',
      account_cancellation_undone: 'Die Kontokündigung lässt sich nicht rückgängig machen. Möchten Sie Ihr Konto wirklich kündigen?',
      no_posts_saved: 'Sie haben noch keine Beiträge gespeichert.',
      no_events_saved: 'Sie haben noch keine Veranstaltungen gespeichert.',
      no_job_offer_saved: 'Sie haben noch keine Stellenangebote gespeichert.',
      confirm_email_address: 'Wir haben Ihnen einen Link zur Bestätigung Ihrer E-Mail an die E-Mail-Adresse <span class="tw-font-bold">{email}</span> gesendet. Überprüfen Sie Ihr E-Mail-Postfach und zur Sicherheit auch Ihren Spam-Ordner.',
      basic_information: 'Wichtige Informationen, die jeder Lebenslauf enthalten muss',
      about_me_input: '2-3 kurze Sätze darüber, wer Sie sind und worauf Sie sich spezialisieren',
      employment: 'Bitte machen Sie Angaben zu Ihrer Beschäftigung. Beginnen Sie mit dem Neusten bzw. Aktuellen.',
      stack: 'Wählen Sie bis zu 9 Spezialisierungen aus, die für Sie am wertvollsten sind und in denen Sie über die meiste Erfahrung verfügen.',
      stack_notify: 'Wir haben bereits einige Technologien aus dem vorherigen Abschnitt für Sie ausgewählt 😎',
      education: 'Geben Sie Informationen zu Ihrer High School, Ihrem College oder Ihrer Universität an. Beginnen Sie mit dem Neuesten.',
      education_diploma_placeholder: 'Diplom-Ingenieur oder so, keine Ahnung, ich habe nicht studiert …',
      references: 'Fügen Sie Informationen zu Projekten hinzu, an denen Sie gearbeitet haben und die bereits online sind.',
      references_description_input: 'Schreiben Sie eine kurze Beschreibung des Projekts oder lassen Sie das Feld leer.',
      certificates: 'Wenn Sie Zeugnisse haben, die Sie vorzeigen möchten, ist hier der richtige Platz dafür.',
      certificates_description_input: 'Verfassen Sie bei Bedarf eine kurze Beschreibung.',
      languages: 'Teilen Sie Ihrem zukünftigen Arbeitgeber mit, welche Sprachen Sie sprechen.',
      technology_input: 'Wählen Sie Technologien aus, die Sie während Ihrer Beschäftigung verwendet haben.',
      employment_description_input: 'Schreiben Sie etwa 3-7 Sätze über Ihren Job und wofür Sie zuständig waren.',
      education_description_input: 'Schreiben Sie etwa 3-6 Sätze über Ihr Studium.',
      cv_generation_in_progress: 'Ihr Lebenslauf wird erstellt. Sobald er fertig ist, erhalten Sie ihn in Ihrem E-Mail-Posteingang: <b>{email}</b',
    },
    actions: {
      fill_position: 'Geben Sie Ihre Position ein',
      respond_to_offer: 'Reagieren Sie auf das Angebot',
      move_down: 'Nach unten',
      move_up: 'Nach oben',
      delete_photo: 'Foto löschen',
      change_photo: 'Foto ändern',
      upload_photo: 'Foto hochladen',
      delete_custom_cv: 'Lebenslauf löschen',
      change_custom_cv: 'Lebenslauf ändern',
      upload_custom_cv: 'Lebenslauf hochladen',
      go_to_events: 'Zu Veranstaltungen gehen',
      show_posts: 'Beiträge anzeigen',
      find_job: 'Stellensuche',
      send_cv_by_email: 'Per E-Mail senden',
      show_resume: 'Lebenslauf ansehen',
      create_koderia_cv: 'Neuen Koderia-Lebenslauf erstellen',
      pick_previous_tech: 'Technologien aus früheren Arbeiten auswählen',
    },
    inputs: {
      dominated_technologies: 'Beherrschte Technologien',
      bio: 'Bio',
      current_email: 'Aktuelle E-Mail',
      new_email: 'Neue E-Mail',
      new_password: 'Neues Passwort',
      url_link: 'URL-Link',
      description: 'Beschreibung',
      country: 'Land',
      education_diploma: 'Ausbildungsabschluss/Diplom',
      school_university: 'Schule/Universität',
      faculty: 'Fakultät',
      technology_software_activity: 'Technologie, Software, Tätigkeit…',
      numbers_of_years_of_experience: 'Anzahl der Jahre an Berufserfahrung',
      language: 'Sprache',
      level: 'Niveau',
      link: 'URL',
      web_social_network: 'Web/Soziales Netzwerk',
      about_me: 'Kurze Informationen über Sie',
      new_jobs: 'Neue Arbeitspositionen',
      koderia_news: 'Koderia-Neuigkeiten',
      profession_finish_up: 'Was beschreibt Ihren Beruf am besten?',
      country_finish_up: 'Woher kommen Sie?',
      technologies_finish_up: 'Welche Technologien verwenden Sie?',
      technologies: 'Technologien',
      non_it: 'Ich bin kein IT-Mensch',
      source_about_us: 'Wie haben Sie von uns erfahren?',
      non_it_registration_reason: 'Warum haben Sie sich für die Registrierung entschieden?',
    },
    posts: 'Beiträge',
    data_in_cv: 'Daten',
    basic_information: 'Basisinformationen',
    education: 'Ausbildung',
    school: 'Schule',
    references: 'Referenzen',
    reference: 'Referenzen',
    technologies: 'Technologien',
    years_of_experience: 'Jahre an Berufserfahrung',
    certificates: 'Zertifikate',
    certificate: 'Zertifikat',
    languages: 'Sprachen',
    experience_chart: 'Erfahrungsdiagramm',
    import_your_data_from: 'Importieren Sie Ihre Daten von',
    linkedin: 'LinkedIn',
    link: 'Link',
    language: 'Sprache',
    app_language: 'Bewerbungssprache',
    contact_information: 'Kontaktdaten',
    privacy: 'Datenschutz',
    graph: 'Diagramm',
    public: 'Öffentlich',
    registered_users: 'Registrierte Benutzer',
    private: 'Privat',
    accessible_with_password: 'Zugänglich mit Passwort',
    job_looking_finish_up: 'Suchen Sie derzeit nach einem Job?',
    job_timeframe_finish_up: 'In welchem',
    job_listing_title: 'Stellenliste',
  },
  gdpr: {
    title: 'Datenschutzrichtlinie',
    default_agree: 'Ich stimme der Verarbeitung personenbezogener Daten gemäß den aktuellen',
    personal_data: 'Richtlinien zum Schutz personenbezogener Daten zu',
    descriptions: {
      privacy_policy_tooltip: 'Durch Anklicken des Kontrollkästchens „Ich stimme der Verarbeitung personenbezogener Daten gemäß den geltenden Grundsätzen des Schutzes personenbezogener Daten zu“ erteilen Sie dem Betreiber die Zustimmung zur Verarbeitung Ihrer personenbezogenen Daten. Der Zweck der Erhebung Ihrer personenbezogenen Daten besteht darin, Ihnen auf Anfrage Informationen über die angemessene Höhe des Gehalts für die konkrete gewählte Position bereitzustellen. Sie erteilen Ihre Zustimmung zur Verarbeitung personenbezogener Daten für einen Zeitraum von 3 Jahren und haben das Recht, diese jederzeit unter der E-Mail-Adresse <u>kontakt@koderia.sk</u> zu widerrufen. Der Widerruf der Zustimmung berührt nicht die Rechtmäßigkeit der Verarbeitung personenbezogener Daten auf Grundlage der Zustimmung vor deren Widerruf.',
      receive_job_offers: 'Ich bin nicht mit der gelegentlichen Zusendung von maßgeschneiderten Stellenangeboten einverstanden',
      contact_tooltip: 'Durch Anklicken des Kontrollkästchens „Ich stimme der Verarbeitung personenbezogener Daten gemäß den geltenden Grundsätzen des Schutzes personenbezogener Daten zu“ erteilen Sie dem Betreiber die Zustimmung zur Verarbeitung Ihrer personenbezogenen Daten und deren Speicherung in der internen Datenbank. Der Zweck der Verarbeitung Ihrer personenbezogenen Daten besteht darin, eine geeignete Arbeitsstelle zu finden. Sie erteilen Ihre Zustimmung zur Verarbeitung personenbezogener Daten für 5 Jahre und haben das Recht, diese jederzeit unter unserer E-Mail-Adresse <u> kontakt@koderia.sk </u> zu widerrufen. Der Widerruf der Zustimmung berührt nicht die Rechtmäßigkeit der Verarbeitung personenbezogener Daten auf Grundlage der Zustimmung vor deren Widerruf.',
      register_account_tooltip: 'Im Rahmen der Registrierung geben Sie durch Anklicken des Kontrollkästchens „Ich stimme der Verarbeitung personenbezogener Daten gemäß der aktuellen Datenschutzrichtlinie zu“ Ihre Zustimmung zur Verarbeitung personenbezogener Daten und deren Speicherung für die Dauer des Bestehens des Kontos. Sie können jederzeit die Löschung des Kontos beantragen und Ihre Zustimmung zur Verarbeitung personenbezogener Daten unter unserer E-Mail-Adresse <u>kontakt@koderia.sk</u> widerrufen. Der Widerruf der Zustimmung berührt nicht die Rechtmäßigkeit der Verarbeitung personenbezogener Daten aufgrund der Zustimmung vor ihrem Widerruf. Auf der Grundlage der Rechtsgrundlage des berechtigten Interesses senden wir Ihnen im Zusammenhang mit der Erstellung eines Kontos unseren Newsletter mit Stellenangeboten und anderen Informationen, die für Sie von Interesse sein könnten. Wenn Sie den Newsletter nicht erhalten möchten, können Sie ihn jederzeit in den Kontoeinstellungen, Abschnitt E-Mail-Einstellungen, abbestellen.',
      newsletter_personalized_offers: 'Ich bin damit einverstanden, personalisierte Stellenangebote und Neuigkeiten zu erhalten',
      newsletter_contact_me_tooltip: 'Durch Anklicken des Kontrollkästchens „Ich bin damit einverstanden, dass Kodeira mich in Zukunft kontaktiert und mir interessante Neuigkeiten sendet“ erteilen Sie dem Betreiber Ihre Zustimmung zur Speicherung personenbezogener Daten in der internen Datenbank zum Zwecke der Zusendung von Marketingangeboten. Der Zweck der Verarbeitung und Speicherung Ihrer personenbezogenen Daten besteht darin, Ihnen Marketingangebote zu senden, die für Sie von Interesse sein könnten. Sie erteilen Ihre Zustimmung zur Verarbeitung personenbezogener Daten im Zusammenhang mit der Erfassung des Newsletters für einen Zeitraum von 5 Jahren und haben das Recht, diese jederzeit auf unserer Website über die E-Mail-Adresse <u>kontakt@koderia.sk</u> zu widerrufen. Der Widerruf der Zustimmung berührt nicht die Rechtmäßigkeit der Verarbeitung personenbezogener Daten auf Grundlage der Zustimmung vor deren Widerruf. Ihr Lebenslauf wird nach Ablauf der Zustimmungsfrist oder nach Widerruf der Zustimmung zur Verarbeitung personenbezogener Daten gelöscht.',
      project_interest_agree_to_contact: 'Ich bin damit einverstanden, dass Koderia mich in Zukunft kontaktiert und mir interessante Neuigkeiten sendet',
    },
  },
  404: {
    title: 'Seite nicht gefunden',
    subtitle: 'Suchen Sie nach einem neuen Job?',
    action: 'Alle Jobs',
  },
  about: {
    title: 'Team von Fachleuten',
    subtitles: {
      way_to_success: 'Unser Weg zum Erfolg',
      outsourcing_pros: 'Vorteile des Outsourcings mit Koderia',
      contractors_db: 'Über 12.000 Auftragnehmer in unserer internen Datenbank',
      personal_approach: 'Persönlicher Ansatz',
      selection_process: 'Hochwertiger Auswahlprozess',
      contact_us: 'Kontaktieren Sie uns',
      koderia_team: 'Koderia-Team',
    },
    descriptions: {
      objectify: 'Koderia kombiniert die Auslagerung von IT-Spezialisten mit umfassenden Dienstleistungen auf verschiedenen Verantwortungsebenen – vom Einsatz eines erfahrenen Teams, das Ihr Projekt agil bearbeitet, bis hin zur Lieferung schlüsselfertiger Software, bei der wir die gesamte Entwicklung von der Beauftragung bis zur Bereitstellung übernehmen. Von Anfang bis Ende. Wir arbeiten langfristig mit führenden Unternehmen in der Slowakei, in Tschechien, Österreich und den USA zusammen.',
      years_of_experience: 'Jahrelange Erfahrung auf dem Markt',
      revenue: 'Umsatz letztes Jahr',
      candidates_count: 'Entwickler',
      enterprise_clients_count: 'Unternehmenskunden',
      satisfied_it: 'Zufriedene IT-Spezialisten',
      monthly_developers_growth: 'Monatlicher Anstieg der Kandidaten in der Datenbank',
      satisfied_clients: 'Zufriedene Kunden',
      delivered_candidates: 'Erfolgreich gelieferte Personentage',
      rocket: {
        '2014': 'Gründung des Softwarehauses <span class="tw-text-koderia-alt tw-font-bold">Objectify, s.r.o.</span>',
        '2019': 'Markenbildung',
        '2022': 'Überschreitung der 2-Millionen-Umsatzgrenze',
        '2025': 'Fusion der Marken <span class="tw-text-koderia-alt tw-font-bold">Objectify und Koderia</span>',
        '2023_1': 'Gehaltsrechner',
        '2023_2': 'mit mehr als 500.000 Verwendungen',
        '2021_1': 'Einrichtung des',
        '2021_2': 'Koderia Lebenslauf',
        '2021_3': 'und Möglichkeit, sich beim Portal anzumelden',
        '2020_1': 'Einführung des konkurrenzlosen',
        '2020_2': 'Gehaltsrechners',
        '2018_1': 'Start des Protals Coders by Coders / Start des Dienstes',
        '2018_2': 'Angemessenes Gehalt',
      },
      contractors_db: 'Und für jeden Programmierer haben wir die Fähigkeiten in Kompetenzzentren aufgeteilt, wo wir Stellenangebote zielgenau vermitteln können. Unsere Spezialisten verfügen über ein breites Spektrum an Fachkenntnissen, darunter Softwareentwicklung, Datensicherheit, Cloud-Technologien und viele andere IT-Bereiche.',
      personal_approach: 'Wir behandeln jeden Auftragnehmer/Programmierer, als ob er in unserem Unternehmen arbeiten würde. Wir glauben, dass unser Team aus professionellen IT-Spezialisten Ihnen nicht nur hochwertige IT-Dienstleistungen bieten kann, sondern auch das Gefühl, mit einem außergewöhnlichen Team zu arbeiten, das sich voll und ganz dem Erfolg Ihrer Projekte verschrieben hat.',
      selection_process: 'Jedes Teammitglied hat einen gründlichen Auswahlprozess durchlaufen und verfügt über Erfahrung mit der Arbeit an verschiedenen Projekten in unterschiedlichen Branchen. Wir stellen professionelle IT-Spezialisten mit umfassender Erfahrung und Fachkenntnissen für die Projekte unserer Kunden zur Verfügung.‘',
      feedback: 'Ihr Feedback ist uns sehr wichtig, da es uns ermöglicht, unsere Dienste zu verbessern und zur Schaffung einer besseren Community für Programmierer beizutragen.',
      count_with_us: 'Wir sind hier, um Ihnen mit Informationen zu helfen und Lösungen zu finden, die Ihren Anforderungen entsprechen.',
      form_sent_thank_you: 'Vielen Dank für Ihre Nachricht!',
    },
    inputs: {
      name: 'Vor- und Nachname *',
      phone: 'Telefonnummer *',
      url: 'Firma oder Linkedin-Profil',
      message: 'Nachricht *',
      gdpr: 'Ich stimme der Verarbeitung personenbezogener Daten zu',
    },
  },
  resume: {
    title: 'Lebenslauf',
    subtitles: {
      modern_clear_cv: 'Ein übersichtlich strukturierter Lebenslauf<br class="tw-hidden lg:tw-block" /> für alle in der IT-Branche.',
      modern_clear_cv_free: 'Kostenlos',
      tailored_cv: 'Auf Ihre Bedürfnisse zugeschnittener Lebenslauf',
      unique_graph: 'Erfahrungen in einer übersichtlichen Grafik dargestellt',
      ready_to_print: 'Lebenslauf bereit zum Drucken und sicheren Teilen',
      experience_salary: 'Der Betrag, den Sie je nach Erfahrung verdienen sollten',
      reviews: 'Bewertungen',
      start_new_cv: 'Beginnen Sie mit dem Schreiben Ihres neuen Lebenslaufs',
      cv_is_secure: 'Der Lebenslauf ist gesichert',
    },
    subheadings: {
      experience_chart: 'Erfahrungsdiagramm',
      print_share: 'Sowohl zum Teilen als auch zum Drucken',
      adequate_salary: 'Angemessenes Gehalt',
      responsive_design: 'Responsives Design',
      english_language: 'Englische Sprache',
      password_protected: 'Passwortgeschützt',
      it_sector_oriented: 'Auf den IT-Sektor ausgerichtet',
      linkedin: 'LinkedIn-Import',
      easy_edit: 'Einfach zu bearbeiten',
      faq_1: 'Ist das Erstellen eines Lebenslaufs wirklich kostenlos?',
      faq_2: 'Wie kann ich meinen Lebenslauf teilen?',
      faq_3: 'Ist der Lebenslauf in anderen Sprachen verfügbar?',
      faq_4: 'Wie importiere ich Daten von LinkedIn in meinen Lebenslauf?',
    },
    descriptions: {
      create_responsive_resume: 'Erstellen Sie in wenigen Minuten einen ansprechenden Lebenslauf, den Sie jederzeit <b>bearbeiten</b>,<br class="tw-hidden lg:tw-block" /> <b>teilen</b> oder <b>drucken</b> können.',
      tailored_cv: 'Koderia CV eignet sich für alle Personen, die in der IT-Branche arbeiten, darunter Frontend-, Backend- und Full-Stack-Entwickler, Tester, IT-Spezialisten, Administratoren oder Datenbankspezialisten.',
      understand_experiences: 'Wie wäre es, Ihre Erfahrungen zu sehen und sie in Sekundenschnelle zu verstehen? Ein Diagramm, das Ihre gesammelten Erfahrungen visualisiert, macht dies möglich.',
      share_and_print: 'Teilen Sie Ihren Lebenslauf mit allen oder nur mit den Personen, für die er bestimmt ist. Drucken Sie ihn bei Bedarf so perfekt aus wie auf dem Bildschirm.',
      experience_salary: 'CV zeigt Ihnen, wie viel Sie basierend auf den in Ihrem Lebenslauf aufgeführten Erfahrungen verdienen sollten.',
      displayed_on_device: 'Der Lebenslauf wird problemlos auf jedem Gerät angezeigt',
      english_switch: 'Sie können Ihren Lebenslauf mit einem Klick auf Englisch umstellen',
      intended_share: 'Zeigen Sie Ihren Lebenslauf allen oder nur den Personen, für die er bestimmt ist',
      unique_design: 'Einzigartiges Lebenslaufdesign für Personen, die einen Job in der IT-Branche suchen',
      linkedin_import: 'Sie können problemlos Daten von Ihrem LinkedIn-Konto in Ihren Lebenslauf übertragen',
      edit_freely: 'Bearbeiten Sie Ihren Lebenslauf bei Bedarf und von jedem Gerät aus',
      faq: 'Wir haben einige Antworten auf Fragen aufgeschrieben, die Sie interessieren könnten. Wenn Sie weitere haben, können Sie uns unter <a href=\'mailto:info@koderia.sk\' class=\'tw-text-underline\'>info@koderia.sk</a> erreichen.',
      faq_1: 'Das ist es. Sie zahlen überhaupt nichts, um Ihren Lebenslauf zu erstellen, zu teilen oder auszudrucken. Keine Werbung, keine versteckten Gebühren. Gern geschehen! 😎',
      faq_2: 'Ihr Lebenslauf ist über einen vorab erstellten Link in der Form <b>koderia.sk/cv/id</b> zugänglich. Sie können diesen Link an jeden senden.',
      faq_3: 'Das ist es. Genau wie unsere Website ist der Lebenslauf in zwei Sprachen verfügbar – Englisch und Slowakisch.',
      faq_4_1: 'Folgen Sie einfach diesen Schritten:',
      faq_4_2: 'Öffnen Sie die Unterseite über Ihre persönlichen Daten auf LinkedIn – So verwendet LinkedIn Ihre Daten',
      faq_4_3: 'Wählen Sie <b>Größeres Datenarchiv herunterladen</b>.',
      faq_4_4: 'Klicken Sie dann auf <b>Archiv anfordern</b>.',
      faq_4_5: 'Entpacken Sie die heruntergeladene Datei und laden Sie die Dateien <b>Sprachen</b>, <b>Kurse</b>, <b>Positionen</b>, <b>Profil</b> und <b>Ausbildung</b> in Ihren Lebenslauf hoch. Klicken Sie dann auf <b>Importieren</b>. Bitte beachten Sie, dass LinkedIn Ihnen die Datei möglicherweise nicht sofort zur Verfügung stellt.',
      ratings: 'Was denken Leute in der IT, die es bereits ausprobiert haben, über Koderia CV? 🥰',
      start_new_cv: 'Wir haben darauf geachtet, dass jeder Lebenslauf perfekt aussieht. Den zweiten Schritt überlassen wir Ihnen.',
      private_access: 'Der Lebenslauf ist entweder privat, für registrierte Benutzer zugänglich oder passwortgeschützt.',
    },
    actions: {
      create_resume: 'Lebenslauf erstellen',
      show_sample: 'Beispiel-Lebenslauf anzeigen',
    },
    invitation: 'Einladung',
  },
  newsletter: {
    subtitles: {
      android_ios_projects: 'Die neusten Android- und iOS-Projekte in Ihr Postfach',
      personalized_jobs: 'Personalisierte Stellenangebote in Ihr Postfach',
    },
    descriptions: {
      send_personalized_projects: 'Wir schicken Ihnen nur personalisierte Projekte, die zu Ihrem Fokus passen.',
      no_spam: 'Kein Spam',
      koderia_newsletter: 'Im Koderia Newsletter finden Sie nur die Stellenangebote, die Sie wirklich interessieren. Niemals Spam.',
    },
  },
  promo: {
    title: 'Projekte für ganze Teams (35+ Personen)',
    description: 'Für neue Projekte aus dem Bankensektor bilden wir neue Teams aus <span class="tw-font-bold">Programmierern</span>, <span class="tw-font-bold">Testern</span> und <span class="tw-font-bold">Scrum Mastern</span>. Arbeiten Sie von zu Hause aus für einen etablierten Kunden...',
  },
  meta: {
    auth_sign_in: 'Anmelden',
    auth_forgot_password: 'Passwort vergessen',
    auth_create_account: 'Konto erstellen',
    work: 'Arbeiten',
    events: 'Events',
    blog: 'Blog',
    newsfeed: 'Newsfeed',
    dictionary: 'Wörterbuch',
    what_is_koderia: 'Was ist Koderia?',
    adequate_salary: 'Angemessenes Gehalt',
    adequate_salary_thank_you: 'Danke – Angemessenes Gehalt',
    calculator: 'Lohnrechner',
    privacy_policy: 'Datenschutzrichtlinie',
    resume: 'Lebenslauf',
    about_us: 'Über uns',
    extra: 'Extra',
    newsletter: 'Newsletter',
    promo: 'Neue Remote-Projekte für ganze Teams (35+ Personen)',
    referral: 'Empfehlung',
    referral_consent: 'Zustimmung – Empfehlung',
    unsubscribe: 'Abmelden',
    account: 'Konto',
    account_saved: 'Gespeichert – Konto',
    account_added: 'Hinzugefügt – Konto',
    my_resume: 'Mein Lebenslauf',
    registration_completion: 'Registrierung abschließen',
    work_types_comparison: 'Vergleich der Arbeitsformen',
    frame_help_bratislava: 'Hilfe für Bratislava beim Aufbau eines neuen Teams von IT-Spezialisten',
    frame_game_industry: 'Arbeit in der Spielebranche',
    frame_net_teams: 'Neue Jobs für .NET-Teams',
    404: 'Seite nicht gefunden',
  },
  reviews: {
    list: {
      1: {
        name: 'Adrián Slavkovský',
        position: 'Koordinator des Inventory Skill Center',
        company: 'Orange S.A.',
        text_1: 'Mitten in einem Projekt haben wir beschlossen, ein weiteres Land in den Integrationsprozess einzubeziehen. Trotzdem gelang es Objectify, das Projekt innerhalb des vereinbarten Zeitrahmens und in hervorragender Qualität abzuliefern.',
        text_2: 'Wir sind sicher, dass wir unsere Zusammenarbeit fortsetzen werden.',
      },
      2: {
        name: 'Ivan Tarapčík',
        position: 'Manager für E-Banking-Lösungen',
        company: 'Asseco Central Europe',
        text: 'Durch die Kombination ihrer Fähigkeiten im Telekommunikationsbereich und der Implementierung in Java haben uns die Leute von Objectify erheblich dabei geholfen, das Notification Center-Projekt pünktlich fertigzustellen.',
      },
    },
  },
  company: {
    services: {
      title: 'Dienstleistungen',
      subtitle: 'Wir sind die Spezialisten für Ihr nächstes IT-Projekt, <br class="tw-hidden sm:tw-block" /> die die Dinge richtig machen.',
      stats: {
        1: 'Entwickler',
        2: 'Umsatz letztes Jahr',
        3: 'Unternehmenskunden',
      },
      fulfilling: {
        title: 'Wir erfüllen alle Ihre IT-Anforderungen. <br class="tw-block md:tw-hidden" /> Von Anfang bis Ende.',
        description: 'Finden Sie den Weg der Zusammenarbeit, der Ihren Bedürfnissen am besten entspricht',
        outsourcing: {
          title: 'Outsourcing',
          description: 'Wir vermitteln Ihnen qualifizierte Fachkräfte, die Ihren Anforderungen entsprechen. Sie haben die Kontrolle.',
        },
        scrum: {
          title: 'Unser Team<br class="{className}" /> für Ihr Projekt',
          description: 'Wir stellen Ihnen ein erfahrenes Entwicklerteam zur Verfügung und sorgen dafür, dass diese mit der bestmöglichen agilen Entwicklungsmethode arbeiten.',
        },
        owning: {
          title: 'Schlüsselfertige Software',
          description: 'Sie geben uns Ihr Ziel, wir liefern die gesamte Lösung. Von Anfang bis Ende.',
        },
        responsibility: {
          title: 'Unsere Verantwortung',
          low: 'Niedrig',
          high: 'Hoch',
        },
      },
      experience: {
        title: 'Unsere Erfahrung – durch Projekte belegt',
        sectors: {
          1: 'Finanzien',
          2: 'TK-Branche',
          3: 'Medizin',
          4: 'Wetten',
          5: 'Transport',
          6: 'IT',
        },
        solutions: {
          1: 'Datenintegration und - migration',
          2: 'Datenwissenschaft / Datenvisualisierung',
          3: 'Dok. Mgmt.',
          4: 'Data Warehouse und Reporting',
          5: 'Web',
          6: 'HR / Sourcing',
          7: 'IT - Projektmanagement',
          8: 'Entwicklung / Betrieb',
        },
        level: {
          expert: 'Experten',
          high_exp: 'Hohe Erfahrung',
          medium_exp: 'Einige Erfahrung',
          low_exp: 'Geringe Erfahrung',
          no_exp: 'Keine Erfahrung',
        },
      },
      benefit: {
        title: 'Vorteile des Outsourcings mit Koderia',
        subtitle: 'Benötigen Sie eine Unternehmenslösung? <br /> Wir erstellen robuste, zuverlässige, skalierbare und schnelle Software.',
        personal_benefits: {
          1: {
            title: 'Über 12.000 Auftragnehmer in unserer internen Datenbank',
            description: 'Und mit Fähigkeiten für jeden Programmierer, die in Kompetenzzentren kategorisiert sind, so dass wir Stellenangebote gezielt ansprechen können. Unsere Spezialisten verfügen über ein breites Spektrum an Fachwissen, darunter Softwareentwicklung, Datensicherheit, Cloud-Technologien und viele andere IT-Bereiche',
          },
          2: {
            title: 'Personalisierter Ansatz',
            description: 'Wir behandeln jeden Auftragnehmer/Programmierer, als wäre er Teil unseres eigenen Unternehmens. Wir glauben, dass unser Team aus professionellen IT-Spezialisten Ihnen nicht nur hochwertige IT-Dienste bieten kann, sondern auch die Erfahrung, mit einem außergewöhnlichen Team zusammenzuarbeiten, das sich voll und ganz dem Erfolg Ihres Projekts verschrieben hat.',
          },
          3: {
            title: 'Hochwertiger Auswahlprozess',
            description: 'Jedes Teammitglied hat einen gründlichen Auswahlprozess durchlaufen und verfügt über Erfahrung mit der Arbeit an verschiedenen Projekten in unterschiedlichen Branchen. Wir stellen professionelle IT-Spezialisten mit umfassender Erfahrung und Fachwissen für die Projekte unserer Kunden zur Verfügung.',
          },
        },
        enterprise_benefits: {
          1: {
            title: 'Datenintegration',
            subtitle: 'Sind Ihre Daten auf mehrere Anwendungen verteilt, sodass Sie keine einzige zusammenfassende Ansicht oder Übersicht erhalten?',
            description: 'In zahlreichen Organisationen ist die Situation ähnlich – Daten sind über viele Anwendungen, verschiedene Standorte oder verschiedene Formate verteilt. Es gibt keine einfache Möglichkeit, alle Daten zu betrachten und auszuwerten. Die Daten müssen kopiert und manuell kombiniert werden, was menschliche Arbeit erfordert und viel Zeit in Anspruch nimmt. <br /> <br /> Wir laden Daten aus allen Arten von Quellen herunter, verschieben und kombinieren sie, unabhängig von Standort oder Technologie. Wir liefern umfassende Berichte, Analysen und grafische Ansichten Ihrer Daten, die die Leistung Ihres Unternehmens erheblich verbessern.',
          },
          2: {
            title: 'Hohe Verfügbarkeit',
            subtitle: 'Verursachen Ausfallzeiten Ihrer IT-Systeme finanzielle Verluste?',
            description: 'Es gibt in der heutigen Welt nicht viele Unternehmen, die sich Ausfälle bei der Bereitstellung von Diensten leisten können, die nicht zur Unzufriedenheit ihrer Kunden führen würden. Wenn eine Anwendung rund um die Uhr verfügbar sein muss, 24 h täglich, 7 Tage pro Woche, ist die Nachfrage nach einem zuverlässigen Dienst, der auch während Upgrades einwandfrei läuft, noch größer. Unsere Lösungen ermöglichen Upgrades ohne Ausfälle bei der Bereitstellung von Diensten. <br /> <br /> Wir implementieren Systeme mit Hochverfügbarkeitsarchitektur, die Ihnen helfen, Systemausfallzeiten zu reduzieren. Die kritischen Komponenten unserer Lösung sind auf alle unerwarteten Ereignisse vorbereitet, die zu Serverausfällen führen könnten.',
          },
          3: {
            title: 'Hohe Skalierbarkeit',
            subtitle: 'Ist Ihr System bereit, eine wachsende Anzahl von Benutzern oder Datenmengen zu bewältigen?',
            description: 'Viele Unternehmen stehen vor dem Problem, dass ihre Systeme nicht in der Lage sind, mehr Kunden mit Dienstleistungen zu versorgen oder dass die Erweiterung ihrer Dienstleistungen zu einer geringeren Qualität führen würde. Die Leistung ihrer Anwendungen begrenzt das Wachstum ihres Unternehmens. <br /> <br /> Wir erstellen Anwendungen, die eine steigende Anzahl von Benutzern, Funktionen, geografischen Standorten und Datenmengen bewältigen können. Unsere Systeme sind an die Anforderungen eines wachsenden Unternehmens anpassbar und hochgradig skalierbar.',
          },
          4: {
            title: 'Automatisiertes Testen',
            subtitle: 'Wie hoch ist der manuelle Testaufwand nach jeder kleinen Änderung im System?',
            description: 'Wenn Sie keine Änderungen am Quellcode einer Anwendung vornehmen können, ohne das Gefühl zu haben, dass etwas nicht mehr funktioniert, ist es an der Zeit, sich mit automatisierten Tests zu befassen. Dasselbe ist ratsam, wenn Ihr Testteam viel Zeit benötigt, um die alte Funktionalität nach jeder Veröffentlichung erneut zu testen. <br /> <br /> Wir helfen Kunden beim Erstellen von Tests, die eine fehlerhafte Funktionalität in Backend-Diensten oder Defekte im Frontend der Anwendung aufdecken. In unseren Projekten verwenden wir testgetriebene Entwicklung. Dabei wird jeder gemeldete Fehler mit einem spezifischen Test behoben. Wir haben auch Testissimo entwickelt – eine einzigartige Lösung für automatisierte UL-Tests.',
          },
        },
        actions: {
          show_more: 'Mehr erfahren',
          show_less: 'Weniger erfahren',
        },
      },
      features: {
        1: {
          title: 'Hohe Skalierbarkeit',
          description: 'Nutzen Sie unsere Entwickler, die den Anforderungen Ihres Projekts entsprechen. Der Rest liegt bei Ihnen.',
        },
        2: {
          title: 'Häufige Releases',
          description: 'Wir veröffentlichen häufig. Nicht alle zwei Wochen, nicht alle vier Wochen, sondern sobald es Sinn ergibt.',
        },
        3: {
          title: 'Duplizieren',
          description: 'Wir stellen sicher, dass wir keine Algorithmen duplizieren. Duplizierung kann die Wurzel allen Übels in der Software sein.',
        },
        4: {
          title: 'Qualitätsprüfung',
          description: 'Wir verwenden Pull Requests, um die Qualität sicherzustellen. Pull Requests ohne automatisierte Tests sind nicht unser Ding.',
        },
        title: 'Wir entwickeln Software seit 2014. Wir lieben Qualität, Wartbarkeit und Funktionalität. <br /> Wir mögen es auch, wenn die Dinge schnell funktionieren.',
      },
    },
    cases: {
      banner: {
        title: 'Wir sind die Spezialisten für Ihr nächstes IT-Projekt, die die Dinge richtig machen.',
        description: 'Wir erfüllen alle Ihre IT-Anforderungen. Von Anfang bis Ende.',
        action: 'Mehr erfahren',
      },
      subtitles: {
        problem_definition: 'Problemdefinition und Ziel',
        challenges: 'Herausforderungen',
        solutions: 'Lösungen',
      },
      competencies: 'Kernkompetenzen',
      technologies: 'Technologien',
      features: {
        data_analytics: 'Datenanalyse',
        data_visualization: 'Datenvisualisierung',
        data_warehouse: 'Data Warehouse',
        data_integration: 'Datenintegration',
        data_modeling: 'Datenmodellierung',
        document_management: 'Dokumentenmanagement',
        distributed_applications: 'Verteilte Anwendungen',
        android_app: 'Entwicklung von Android-Apps',
        application_integration: 'Anwendungsintegration',
        agile_development: 'Agile Entwicklung',
        automated_testing: 'Automatisiertes Testen',
        high_availability: 'Hohe Verfügbarkeit',
        high_scalability: 'Hohe Skalierbarkeit',
        high_data_volume_processing: 'Verarbeitung großer Datenmengen',
        microservices: 'Mikroservices',
      },
      domains: {
        railways: 'Eisenbahnen',
        construction: 'Bauwesen',
        renewable_energy: 'Erneuerbare Energien',
        biometrics: 'Biometrie',
        telecommunications: 'Telekommunikation',
        healthcare: 'Gesundheitswesen',
        community: 'Gemeinschaft',
      },
      list: {
        railways: {
          title: 'Data Warehouse für Schienendefektoskopie',
          description: 'Die Eisenbahnen der Slowakischen Republik bestellten bei einem Konsortium von Unternehmen ein Diagnosefahrzeug für zerstörungsfreie Prüfungen, das das Fahrzeug, Messtechnologien und die Software zur Auswertung aller gemessenen Daten lieferte. Für dieses Konsortium erstellten wir ein Lager und ein Analysetool, das die Daten in einem benutzerfreundlichen Portal anzeigt.',
          problem_definition: 'Messsysteme erzeugen eine riesige Datenmenge, die in einen Datenspeicher übertragen und später bereinigt und in ein für den normalen Benutzer verständliches Format umgewandelt werden muss. Aufgrund der Größe der Datenbank, die auf ca. 5 TB geschätzt wird, müssen die Daten in ein Format umgewandelt werden, das für die spätere Anzeige auf dem Portal optimiert ist. Die Anwendung muss eine Benutzeroberfläche bieten, die die angeforderten Daten mit schnellen Reaktionszeiten anzeigt und die Messdaten auf einer zugrunde liegenden Karte darstellen kann.',
          challenge: {
            description: 'Das Projekt umfasst eine große Menge an Messdaten, die von einer Lokomotive auf einen Server übertragen und anschließend bereinigt und in ein Format umgewandelt werden müssen, das eine spätere Datenanalyse ermöglicht und kurze Reaktionszeiten für die Präsentationsebene bietet.',
            list: {
              1: {
                title: 'Zusammenarbeit mehrerer Anbieter',
                description: 'Eine der Herausforderungen bestand auch darin, die Zusammenarbeit zwischen mehreren Unternehmen zu arrangieren, darunter mehrere Anbieter von Messsystemen und mehrere Anbieter von Softwarelösungen.',
              },
              2: {
                title: 'Über den Kunden',
                description: 'Die Eisenbahnen der Slowakischen Republik verwalten die staatliche Eisenbahninfrastruktur auf dem Gebiet der Slowakischen Republik und bieten gleichzeitig auch Transportdienstleistungen an.',
              },
            },
          },
          solution: {
            description: 'Das Data Warehouse konsolidiert große Mengen an Informationen, die von in der Lokomotive installierten Messsystemen gesammelt werden. Dieses Warehouse speichert, bereinigt und wandelt Rohmessdaten effizient in ein strukturiertes Format um, was umfassende Analysen und Berichte ermöglicht. Es unterstützt erweiterte Datenanalysen und erleichtert die Identifizierung von Schienenfehlern, Trends und Mustern im Laufe der Zeit.',
            list: {
              1: {
                title: 'Kampagnen',
                description: 'Die Messungen ausgewählter Gleisabschnitte werden im Rahmen einer Messkampagne im Voraus geplant. Beim Erstellen einer Kampagne muss der Benutzer den gesamten Routenplan für das Diagnosefahrzeug definieren, einschließlich Details zur Geschwindigkeit des Fahrzeugs, zu Diagnosearten und geplanten Stopps an Bahnhöfen.',
              },
              2: {
                description: 'Nach Abschluss einer Kampagne kann der Benutzer die gesammelten Daten anzeigen und analysieren. Es ist möglich, die von den Messsystemen erstellten Originaldateien herunterzuladen, Bilder oder Videos von Kameras anzuzeigen und die Fehler auf einer Karte zu lokalisieren.',
              },
              3: {
                description: 'Kampagnen und alle zugehörigen Dateien haben ihren eigenen Lebenszyklus, der den Benutzern hilft, die Ergebnisse zu analysieren und nachfolgende Reparaturen zu planen.',
              },
              4: {
                title: 'Dashboard',
                description: 'Die Anwendung verfügt über ein umfassendes Dashboard mit interaktiven Kacheln, mit denen Benutzer problemlos zu verschiedenen Bildschirmen wie Berichten, Kampagnen oder Dateien navigieren können. Jede Kachel bietet schnellen Zugriff auf verschiedene Funktionen und gewährleistet so eine intuitive und effiziente Benutzerumgebung. Das Dashboard dient als zentrale Anlaufstelle und bietet einen Überblick über wichtige Informationen und Funktionen. Benutzer können auf detaillierte Berichte zugreifen, Kampagnendaten verwalten und direkt vom Dashboard aus zu allen anderen Bildschirmen navigieren.',
              },
              5: {
                title: 'Berichte',
                description: 'Die Anwendung enthält eine Vielzahl von Berichten zur Unterstützung umfassender Datenanalysen und Entscheidungsfindungen. Diese Berichte umfassen Messergebnisse, die die während der Kampagnen gesammelten Daten detailliert beschreiben. Fehlerberichte heben alle in den Daten erkannten Anomalien oder Probleme hervor. Abschnittsbewertungsberichte bieten eine Bewertung bestimmter Gleisabschnitte, während Statusberichte von Messungen Echtzeit-Updates zum Fortschritt und den Ergebnissen laufender Messungen bieten. Darüber hinaus präsentieren Frontalfotoberichte visuelle Dokumentationen von Kameras und helfen so bei der Identifizierung und Überprüfung von Mängeln. Jeder Bericht soll klare und umsetzbare Erkenntnisse liefern und so die allgemeine Effizienz und Effektivität des Schienenwartungsprozesses verbessern.',
              },
            },
          },
        },
        cx_android: {
          title: 'Cx Android App',
          description: 'Die Anwendung bietet Funktionen zur Verwaltung von Aufgaben im Zusammenhang mit der Inbetriebnahme von Bauprojekten. Sie erleichtert die kollaborative Problemverwaltung, verfolgt Vermögenswerte und gewährleistet die Qualitätsprüfung mithilfe von Checklisten und Tests.',
          problem_definition: 'Unser Kunde verfügte über eine bestehende Inbetriebnahme-Management-Software, die über einen Webbrowser als normale Webanwendung oder als iOS-Anwendung im App Store zugänglich war. Sie benötigten eine Android-App, die identische Funktionen wie die iOS-App bietet.',
          challenge: {
            list: {
              1: {
                title: 'Kunde',
                description: 'CxAlloy bietet Kunden in Nordamerika  Inbetriebnahme-Management-Software und Facility-Management-Software.',
              },
              2: {
                title: 'Grundfunktionen',
                list: {
                  1: 'Unterstützung mehrerer Projekte',
                  2: 'Automatische Synchronisierung mit dem Server',
                  3: 'Verwendung im Offlinemodus',
                  4: 'Erstellung und Änderung von Feldbeobachtungen',
                  5: 'Qualitätsüberprüfung anhand von Checklisten und Tests',
                  6: 'Problemmanagement',
                  7: 'Vermögensverfolgung',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'Die Anwendung ermöglicht es Benutzern, mehrere Projekte zu verwalten. Sie gewährleistet die Synchronisierung von Datenänderungen zwischen dem Client und dem Anwendungsserver. Mehrere Benutzer können gleichzeitig auf verschiedenen Plattformen (iOS, Web, Android) am selben Projekt arbeiten. Fortschrittliche Algorithmen auf der Serverseite gewährleisten die Integrität und Korrektheit der Daten, wenn dasselbe Projekt parallel von verschiedenen Benutzern verwendet wird. <br /> <br /> Jedem Projekt können verschiedene Dateien und Dateitypen (z. B. Bilder oder PDFs) angehängt werden. Zusätzlich können Benutzer diesen Dateien Anmerkungen hinzufügen, die in einer Ebene über der Datei angezeigt werden. Diese Anmerkungsebene kann nach Bedarf bearbeitet werden.',
              },
              2: {
                description: 'Feldbeobachtungen ermöglichen es Benutzern, ihren Fortschritt bei den Bauaktivitäten vor Ort zu dokumentieren. Diese Beobachtungen können von verschiedenen Projektrollen genutzt werden, darunter Architekten, Ingenieure oder Berater. Die Verwaltung von Feldbeobachtungen umfasst auch die Möglichkeit, Kommentare zu erstellen und zubearbeiten, mit Optionen zum Anhängen von Bildern.',
              },
              3: {
                title: 'Problemverfolgung',
                description: 'Die Anwendung ermöglicht eine effiziente Zusammenarbeit bei Design- und Konstruktionsproblemen, die aus verschiedenen Quellen wie Feldbeobachtungen oder Tests stammen können. Probleme können Mängel, Fragen oder Kommentare umfassen. Ein Fluss zwischen verschiedenen Zuständen eines Problems wird von der Anwendung unterstützt, was zur Erstellung zusätzlicher Aufgaben oder zur Zuweisung eines Problems an verschiedene Personen führen kann. Die Anwendung enthält auch Problemvorlagen, die die Erstellung neuer Probleme vereinfachen.',
              },
            },
          },
        },
        pv_components: {
          title: 'Katalog für Photovoltaikkomponenten',
          description: 'Wir haben eine Webanwendung erstellt, deren Hauptziele darin bestehen, Zugriff auf genaue und überprüfte technische Spezifikationen von PV-Komponenten wie PV-Modulen oder Wechselrichtern zu bieten.',
          problem_definition: 'Die meisten Hersteller von Photovoltaikkomponenten präsentieren ihre Produkte hauptsächlich auf ihren jeweiligen Websites. Wenn Benutzer jedoch Artikel mehrerer Hersteller auf standardisierte Weise vergleichen und bewerten möchten, gibt es nur wenige öffentliche Portale, die solche Vergleiche ermöglichen. Ein wesentliches Ziel dieses Projekts war es, Photovoltaik-Komponenten aus verschiedenen Regionen oder von verschiedenen Herstellern zusammenhängend darzustellen. <br /> <br /> Ebenso wichtig ist die Bereitstellung einer API für Anwendungen Dritter, damit diese Portaldaten für ihre eigenen Zwecke nutzen und ihre Kunden besser bedienen können. Beispielsweise könnte diese API bei der Bewertung verschiedener Produkttypen für die Planung eines Photovoltaikkraftwerks helfen.',
          challenge: {
            list: {
              1: {
                title: 'Implementierung',
                list: {
                  1: 'Serverlose Architektur auf AWS',
                  2: 'Facettennavigation nur mit PostgreSQL (ohne Verwendung von ElasticSearch oder Solr)',
                  3: 'Komplexe mathematische Validierungen',
                },
              },
              2: {
                title: 'Kunde',
                description: 'Unser Kunde ist ein führender Anbieter von Photovoltaik-Softwareanwendungen und Weblösungen zur Optimierung des Baus, der Bewertung und des Managements von Solarenergieanlagen.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Grundfunktionen',
                list: {
                  1: 'Registrierung von PV-Komponenten, einschließlich Unterstützung mehrerer Versionen einer Komponente',
                  2: 'Validierungen und Berechnungen von Komponentenattributen',
                  3: 'Suchfunktionen (Volltextsuche, Facettensuche)',
                  4: 'Vergleiche von Komponenten',
                  5: 'Rest-API für Anwendungen von Drittanbietern',
                  6: 'Exporte und Importe von Komponenten in häufig verwendeten Formaten',
                },
              },
              2: {
                title: 'Komponentenkatalog',
                description: 'Die Anwendung ermöglicht es Benutzern, eine Liste von Artikeln anzuzeigen, die nach verschiedenen Kriterien wie Herstellername, mechanische oder elektrische Eigenschaften und mehr gefiltert werden können. Darüber hinaus werden Volltextsuche und Facettensuche bereitgestellt, um Benutzern die bequeme Suche auf dem Portal zu erleichtern. <br /> <br /> Die Anwendung ist öffentlich zugänglich.',
                a_tag: 'Zum PV-Komponentenkatalog',
              },
              3: {
                title: 'Statistiken',
                description: 'Zusätzlich zur Grundfunktionalität der Kataloganzeige bietet die Anwendung Bildschirme für Führungskräfte, die ihnen den Zugriff auf statistische Informationen über die im Katalog angezeigten oder von Drittunternehmen verwendeten Artikelsammlungen ermöglichen. Darüber hinaus ist die Bereitstellung statistischer Berichte zur API-Nutzung ausgewählter Unternehmen ein Standardfeature des Portals.',
              },
              4: {
                title: 'Verwaltung',
                description: 'Der Verwaltungsbereich des Portals ermöglicht eine umfassende Verwaltung von Benutzern und Unternehmen. Er ermöglicht die Registrierung und Verwaltung von Benutzerkonten, die Überwachung von Unternehmensregistrierungen und die Überprüfung der Genauigkeit und Vollständigkeit von Komponentendaten. Darüber hinaus enthält er Tools zur Überwachung von Aktivitäten im Zusammenhang mit der API-Nutzung durch Drittanbieteranwendungen.',
              },
              5: {
                title: 'Technologien',
              },
            },
          },
        },
        enrollment: {
          title: 'Registrierungsportal',
          description: 'Biometrische Identifikationslösungen für verschiedene Zwecke, von der zivilrechtlichen Identifizierung bis hin zu strafrechtlichen Ermittlungen.',
          features: {
            0: 'Agile Entwicklung',
            1: 'Datenvisualisierung',
            2: 'Anwendungsintegration',
          },
          problem_definition: 'Wir haben eine Lösung zur Erfassung biometrischer Daten mithilfe von Bibliotheken und SDKs implementiert, die von Innovatrics erstellt wurden. Die Portallösung bietet Funktionen, die für die zivilrechtliche Identifizierung oder strafrechtliche Ermittlungen genutzt werden können. Die Anwendung ermöglicht die Verwendung verschiedener Geräte zur Erfassung von Fingerabdrücken oder Iris-Scans. Darüber hinaus werden verschiedenste Kameratypen unterstützt.',
          challenge: {
            list: {
              1: {
                title: 'Kunde',
                description: 'Innovatrics ist ein unabhängiger, in der EU ansässiger Anbieter vertrauenswürdiger biometrischer Lösungen für Regierungen und Unternehmen.',
              },
              2: {
                title: 'Grundfunktionen',
                list: {
                  1: 'Gesichtsdetektion und Gesichtserkennung',
                  2: 'Iris-Scans',
                  3: 'Flache und gerollte Fingerabdruckscans',
                  4: 'Handflächen-Scans',
                  5: 'Handschriftliche Unterschriften',
                },
              },
            },
          },
          solution: {
            list: {
              1: {
                description: 'Alle Modalitäten, die von Bewerbern eingeholt werden, sind konfigurierbar. Das bedeutet, dass sich der Kunde für einen Einsatz nur mit Unterstützung beispielsweise von Gesichtserkennung und flachen Fingerabdruckscans oder für einen Einsatz mit Unterstützung aller Funktionen entscheiden kann.<br /> <br />Gesichtsdetektion und anschließende Gesichtserkennung sind die Grundfunktionen des Registrierungsportals. Iris-Scans gehören ebenfalls zu den normalen Funktionen der App.',
              },
              2: {
                title: 'Fingerabdruckscans',
                description: 'Die Anwendung unterstützt sowohl flache als auch gerollte Fingerabdruckscans. Mit der flachen Methode können Benutzer zwischen dem Mehrfinger-Erfassungsmodus und einzelnen Fingerscans wechseln',
              },
              3: {
                title: 'Bewerberidentifikation',
                description: 'Im letzten Schritt verwendet das System biometrische Erkennungstechnologien, um den Bewerber zu identifizieren. Die Anwendung nutzt Gesichtserkennung, Iris-Scans und Fingerabdruckdaten und verwendet ausgefeilte Algorithmen, um die erfassten biometrischen Informationen mit vorhandenen Datensätzen in ihrer Datenbank abzugleichen. Durch den Einsatz dieser robusten biometrischen Modalitäten gewährleistet die Anwendung ein hohes Maß an Genauigkeit und Sicherheit im Identifizierungsprozess und ermöglicht zuverlässige Entscheidungen in verschiedenen Szenarien, von der zivilrechtlichen Identifizierung bis zur strafrechtlichen Ermittlung.',
              },
            },
          },
        },
        sia: {
          title: 'SIA – Service Impact Analysis',
          description: 'SIA ist eine Weiterentwicklung unseres vorherigen Projekts CELINE, dessen Ziel die Integration verschiedener Bestandsdatenquellen in eine Anwendung war. Obwohl CELINE für Orange France entwickelt wurde, erregte das Projekt die Aufmerksamkeit der gesamten Orange-Gruppe. Insbesondere Orange Slovakia hatte die Anforderung, nicht nur ihre Bestandsdatenquelle zu integrieren, sondern diese Daten auch zur Beantwortung scheinbar einfacher Fragen zu verwenden: Was würde passieren, wenn ein bestimmtes Netzwerkelement ausfällt? Welche Dienste und Kunden könnten betroffen sein und wie wird sich der Ausfall im Netzwerk ausbreiten? Wir haben SIA entwickelt, um diese Fragen zu beantworten.',
          problem_definition: {
            text_1: 'Es gibt drei Situationen, in denen ein Benutzer große Datenmengen zusammenfassen muss, um eine Antwort auf eine Frage zu den möglichen Auswirkungen auf Kunden und ihre Produkte zu finden.',
            list: {
              1: 'Im Falle einer geplanten Modernisierung, Stilllegung oder Änderung eines Netzelements, die dessen Funktionalität beeinträchtigen könnte',
              2: 'Im Falle eines Geräteausfalls, der von Betriebsteams und Überwachungstools festgestellt wurde',
              3: 'Im Falle von Kundenbeschwerden über Servicestörungen',
            },
            text_2: 'In all diesen Situationen mussten viele Benutzer zusammenarbeiten, auf viele Tools zugreifen und die Ergebnisse zusammenstellen, um die entsprechende Antwort zu finden. Dieser Prozess ist fehleranfällig und kann in komplizierteren Fällen (z. B. Außerbetriebnahme eines Glasfaserkabels in der Stadt) zwei Wochen dauern.',
          },
          challenge: {
            description: 'Wir mussten uns den gleichen Herausforderungen stellen wie beim CELINE-Projekt. Dieses Projekt treibt geht die Anforderungen noch weiter und bringt daher zusätzlich zu denen des CELINE-Projekts eine Reihe neuer Herausforderungen mit sich.',
            list: {
              1: {
                title: 'Beziehungen in riesigen Diagrammen in Echtzeit finden.',
                description: 'Wenn Sie alle Dienste berechnen möchten, die beispielsweise auf ein bestimmtes Glasfaserkabel in einer Stadt angewiesen sind, benötigen Sie nicht nur qualitativ hochwertige und stark korrelierte Daten, sondern müssen auch große Teile des Netzwerks sowohl vertikal als auch horizontal untersuchen. Das Problem bei solchen Berichten ist auch, dass Sie nicht wissen, wie „tief“ Sie suchen müssen.',
              },
              2: {
                title: 'Fehlende Daten vervollständigen',
                description: 'Obwohl wir die Daten aller vorhandenen Inventarsysteme und aller Netzwerkmanagementsysteme bei Orange Slovakia erfolgreich korrelierten, gab es immer noch Lücken, die wir schließen mussten, um ein vollständiges Bild des Netzwerks zu erhalten. Beispielsweise gab es keine Datenquelle, die die Servicearchitektur bestimmter Netzwerkelemente detailliert beschreiben würde.',
              },
              3: {
                title: 'Visualisierung der Auswirkungen',
                description: 'Die Anforderungen bestanden darin, eine Liste der Dienste und Kunden bereitzustellen, die von Ausfällen von Netzwerkelementen betroffen sind. Diese Liste wird beispielsweise verwendet, um Kunden über geplante Ausfälle zu informieren. Selbst wenn wir die Liste gehabt hätten, wäre die Frage aufgetaucht: „Wie könnte der Benutzer überprüfen, ob die Liste korrekt ist?“ Eine weitere Frage, die wir im Hinterkopf behalten mussten, war: „Wie könnte der Benutzer verstehen, welche Kette von Ausfällen Auswirkungen auf diesen bestimmten Kunden hat?“',
              },
            },
          },
          solution: {
            description: 'Glücklicherweise hatten wir bereits ein Produktionssystem im Betrieb und viel Erfahrung in der Integration von Telekommunikationsinventar aus unserem vorherigen CELINE-Projekt. Wir haben uns entschieden, unsere Lösungen und unseren Code wiederzuverwenden. Wir nutzten diese Gelegenheit auch, um unseren Code zu modernisieren, wichtige Teile, die später optimiert werden sollten, umzugestalten und ein besseres Produkt für den Einsatz sowohl im CELINE- als auch im SIA-Projekt zu schaffen.',
            list: {
              1: {
                title: 'Beziehungen in riesigen Graphen in Echtzeit finden',
                description: 'Wir haben uns entschieden, unsere standardmäßige relationale Datenbank weiterhin als unseren primären persistenten Speicher zu verwenden. Um jedoch in den riesigen Graphen in Echtzeit suchen zu können, haben wir eine spezielle Graphendatenbank, NEO4J, eingeführt, die unsere Möglichkeiten zur Durchführung von Analysen des Telekommunikationsnetzwerks erheblich erweitert hat. Die Daten in NEO4j werden von unserer primären persistenten Datenbank synchronisiert und denormalisiert und verbessert, um die Netzwerkauswirkungsanalysen weiter zu beschleunigen.',
              },
              2: {
                title: 'Fehlende Daten vervollständigen',
                description: 'Wir mussten die Implementierung unseres Tools so modifizieren, dass es nicht nur aus anderen Systemen integrierte Daten anzeigt und analysiert, sondern dem Benutzer auch ermöglicht, diese Daten zu ändern und weiter zu verbessern. Ein Teil der fehlenden Daten war die Service-Architektur, die natürlich die Form eines Diagramms hat. Wir haben eine spezielle DSL (domänenspezifische Sprache) entwickelt, die eine sehr effiziente Erstellung eines solchen Diagramms aus grundlegenden Inventarobjekten ermöglicht',
              },
              3: {
                title: 'Visualisierung der Auswirkungen',
                description: 'Um dem Benutzer mehr Informationen über die Merkmale der Auswirkung oder die Gründe zu liefern, warum das Tool einige Kunden in den Auswirkungsbericht aufgenommen hat, mussten wir spezielle Ansichten der Auswirkungsdaten entwerfen. Beispielsweise können Benutzer die Auswirkungen auf einer Karte visualisieren, um zu sehen, wie sich die Auswirkungen eines Ausfalls an einem Standort über den geografischen Raum ausbreiten. Darüber hinaus können Benutzer den gesamten Pfad von bestimmten Kundengeräten bis zu den Netzwerkelementen visualisieren, die von allen Kunden für einen bestimmten Dienst verwendet werden.',
              },
            },
          },
        },
        celine: {
          title: 'Celine',
          description: 'CELINE ist ein übergeordnetes Bestandsverwaltungssystem, das Daten von Orange-Tochtergesellschaften zu ihrer Netzwerkinfrastruktur sammelt und einheitlich präsentiert. CELINE wird vom GNOC (Global Network Operation Center) verwendet, das für den Betrieb der Netzwerke in verschiedenen Orange-Tochtergesellschaften verantwortlich ist. GNOC verwendet CELINE als primäre Quelle für Bestandsdaten bezüglich der von ihm verwalteten Netzwerkinfrastruktur.',
          problem_definition: {
            text: 'CELINE wurde für GNOC (Global Network Operation Center) entwickelt. GNOC ist für die Wartung der Netzwerkinfrastruktur der Orange-Tochtergesellschaften verantwortlich. Um dieses Ziel zu erreichen, ist der Zugriff auf Informationen über die Netzwerkinfrastruktur von größter Bedeutung. <br /> <br /> Der ursprüngliche Ansatz von GNOC hinsichtlich der Bestandsverwaltung bestand darin, auf alle Tools zuzugreifen, die in dem Land verfügbar sind, für das sie Dienste bereitstellen. Schon früh war klar, dass die Arbeit mit verschiedenen Systemen von riesigen Bestandslösungen wie NetCracker bis hin zu Excel-Tabellen nicht effizient war. Daher wurde festgestellt, dass es eine einzige Bestandslösung für GNOC geben sollte, die alle verfügbaren Datenquellen integriert. Man könnte die Situation wie folgt beschreiben:',
            header_1: 'Vor CELINE',
            header_2: 'Nach CELINE',
          },
          challenge: {
            description: 'Die Firma OBJECTIFY war von Anfang an Teil des CELINE-Projekts. Unser erster Beitrag zum Projekt bestand darin, das Problem zu definieren, mit dem das GNOC konfrontiert war: den Zugriff auf Informationen, die über viele verschiedene Datenquellen verstreut sind. Bald war klar, dass wir vor vielen großen Herausforderungen stehen würden:',
            list: {
              1: {
                title: 'Datenvielfalt',
                description: 'Die Anwendungen, die die Daten der Netzwerkinfrastruktur speicherten, unterschieden sich stark voneinander in Bezug auf APIs, Detaillierungsgrad und Datenmodelle. Unser Ziel war es, eine einheitliche Ansicht der Daten für den Benutzer zu erstellen. Aus Benutzersicht sollte die Darstellung beispielsweise eines Servers oder Routers  dieselbe sein, unabhängig davon, ob die Originaldaten aus NMS (Netzwerkmanagementsystemen), Excel-Tabellen oder Inventarisierungstools stammen.',
              },
              2: {
                title: 'Datensynchronisierung',
                description: 'Es war nicht möglich, alle von Orange-Tochtergesellschaften verwendeten Tools zu ersetzen, da sie Teil der täglichen Arbeit der lokalen Ingenieure sind und in andere spezifische IT-Lösungen integriert sind.',
              },
              3: {
                title: 'Informationen statt Daten',
                description: 'Selbst wenn sich Daten aus verschiedenen Datenquellen in derselben Anwendung befinden, müssen diese Daten miteinander korreliert, in Benutzerberichten zusammengefasst und über standardisierte APIs für weitere Automatisierungs- und Berichtstools zugänglich gemacht werden, um einen echten Nutzen zu bieten.',
              },
              4: {
                title: 'Sicherung der Datenqualität',
                description: 'Es kommt häufig vor, dass Bestandssysteme veraltete Daten enthalten. Das Problem verschärft sich, wenn Drittunternehmen ohne Verwaltungsbefugnis (GNOC) eine Datenbereinigung einleiten oder veraltete Daten aktualisieren müssen.',
              },
            },
            post_list_description: 'Projekte mit so vielen Teilnehmern bringen erhebliche Projektmanagementprobleme mit sich, aber das geht über den Rahmen dieser Fallstudie hinaus.',
          },
          solution: {
            description: 'Die Firma OBJECTIFY war schon lange vor diesem Projekt im Telekommunikations-Bestandsmanagement aktiv. Dank unserer Erfahrung haben wir wertvolles Fachwissen erworben, ohne das wir diese Lösungen niemals  hätten liefern könnten:',
            list: {
              1: {
                title: 'Datenvielfalt',
                description: 'Wir haben ein Inventardatenmodell erstellt, das mit einer sehr allgemeinen Terminologie beginnt und zu spezifischeren Typen übergeht. Dieses Modell war erweiterbar und konnte jede mögliche Bestandssituation in Datenquellen dokumentieren, die zu diesem Zeitpunkt noch nicht einmal identifiziert waren. Das Ergebnis war ein „Common Data Model“, das wir ausführlich beschrieben und getestet haben',
              },
              2: {
                title: 'Datensynchronisierungen',
                description: 'Wir haben spezielle Datenpumpen erstellt, um Daten zu sammeln und in das „gemeinsame Datenmodell“ umzuwandeln und die aggregierte Ansicht nach jeder Synchronisierung an ein zentrales Inventar in Polen zu senden. Diese Datenpumpen ermöglichen benutzerdefinierte Verbindungen und Transformationen für jede Datenquelle. Alle nachgelagerten Berechnungen, Transformationen und Algorithmen sind generisch und unabhängig von der Datenquelle.',
              },
              3: {
                title: 'Sicherung der Datenqualität',
                description: 'Wir müssen immer sicherstellen, dass die dem Benutzer präsentierten Daten korrekt sind. Wir haben Mechanismen implementiert, um Dateninkonsistenzen wie Referenzintegrität und Dateninvarianten zu identifizieren. Wir haben es Benutzern auch ermöglicht, Daten aus einem Quellsystem zu überschreiben und gleichzeitig sicherzustellen, dass solche Korrekturen in der gesamten Anwendung konsistent sichtbar sind (der ursprüngliche Wert aus der Datenquelle und der korrigierte Wert von GNOC).',
              },
              4: {
                title: 'Informationen statt Daten',
                description: 'Dass der Benutzer über die Daten verfügt, bedeutet nicht, dass er alle benötigten Informationen erhält. Um dieses Problem zu lösen, haben wir großen Wert auf Suchfunktionen für alle Inventarobjekte und -attribute gelegt. Teil der CELINE-Lösung ist die Integration mit unserem eigenen DMS-Tool, das Speicher für unstrukturierte Daten (Arbeitsanweisungen, Handbücher, häufige Probleme und Lösungen) bereitstellt und diese Informationen in CELINE integriert. Wir haben auch viele benutzerdefinierte Berichte entworfen und implementiert, die auf die täglichen Informationsanforderungen der GNOC-Ingenieure zugeschnitten sind. Diese Berichte ermöglichen eine aggregierte Ansicht von Daten aus verschiedenen Quellen.',
              },
            },
          },
        },
        dms: {
          title: 'DMS',
          description: 'Die DMS-Anwendung ist ein zentraler, webbasierter Speicher für alle digitalen Inhalte: Dokumente, Fotos, Wiki-Seiten und Entscheidungsbäume. Sie ist für die horizontale Skalierung konzipiert, um große Datenmengen verarbeiten zu können. Teil der Lösung ist ein regelbasierter Loader, der eine Verbindung zu verschiedenen Datenquellen herstellen und Inhalte ins DMS migrieren oder synchronisieren kann.',
          problem_definition: 'Zum Aufbau der Netzwerkinfrastruktur für Telekommunikationsbetreiber gehört die Erstellung vieler verschiedener Dokumente wie Mietverträge, CAD-Zeichnungen, Messungen, Installationsmaterialien usw. Wenn der Telekommunikationsstandort betriebsbereit ist, werden andere Aktivitäten wie Standortrevisionen durchgeführt, die weitere Dokumentation generieren. <br /> <br /> Alle diese Dokumente wurden zuvor auf einem einzigen freigegebenen Laufwerk gespeichert, und mit zunehmender Dokumentenmenge wurde es immer schwieriger, die richtigen zu finden. Um dieses Problem zu lösen, begannen Benutzer, ihre eigenen Ordnerhierarchien zu erstellen, was bedeutete, dass einige der Dokumente dupliziert wurden. Das gemeinsam genutzte Laufwerk hatte auch andere Probleme, wie fehlende Volltextsuche, keine Rückverfolgbarkeit, schlechte Benutzerrechteverwaltung usw., die gelöst werden mussten.',
          challenge: {
            description: 'Dieses Projekt umfasste eine große Menge unstrukturierter Daten, die kategorisiert werden mussten, damit Benutzer finden konnten, was sie brauchten, egal welche Rolle sie in der Organisation spielten. Die Dokumente wurden sowohl von internen Orange-Mitarbeitern als auch von Benutzern externer Unternehmen erstellt und verwendet.',
            list: {
              1: {
                title: 'Dokumentenorganisation',
                description: 'Aus der Analyse der auf der gemeinsam genutzten Festplatte gespeicherten Dokumente wurde deutlich, dass Benutzer unterschiedliche „Ansichten“ über die Kategorisierung von Dokumenten haben. Für einige Benutzer war die Kategorisierung „standortorientiert“, während andere Benutzer nach „zeitorientierten“ Prioritäten kategorisierten. Dies führte zu unterschiedlichen Ordnerhierarchien und einer Fragmentierung der Dokumente.',
              },
              2: {
                title: 'Strukturierte und unstrukturierte Daten',
                description: 'Obwohl die meisten Daten in Dokumenten gespeichert waren, wurden einige Informationen in den Ordnerstrukturen selbst gespeichert. Dokumenttyp, Site-Nummer, Jahr und vieles mehr wurden in Ordnernamen verschlüsselt, was die ordnungsgemäße Verwendung dieser Informationen verhinderte.',
              },
              3: {
                title: 'Duplizierung und Qualitätssicherung',
                description: 'Es kam häufig vor, dass Benutzer einige obligatorische Ordner übersahen, was dazu führte, dass Dokumente falsch kategorisiert oder ein bereits vorhandenes Dokument hochgeladen wurden.',
              },
              4: {
                title: 'Suche',
                description: 'Das Hauptproblem des Dokumentenspeichersystems mit gemeinsam genutzter Festplatte war die schlechte Benutzerfreundlichkeit bei der Suche nach Dokumenten. Es war nicht möglich, eine Volltextsuche zu verwenden, und es war schwierig, durch Ordnerhierarchien zu navigieren und Duplikate aufzulösen.',
              },
              5: {
                title: 'Sicherheit und Nachverfolgbarkeit',
                description: 'Wenn Benutzer Dokumente an einen anderen Ort verschoben oder versehentlich gelöscht hatten, konnte nicht festgestellt werden, um welchen Benutzer es sich handelte. Es war auch nicht einfach, Dokumente vor unbefugtem Zugriff zu schützen.',
              },
              6: {
                title: 'Datenimport',
                description: 'Auf dem gemeinsam genutzten Laufwerk war bereits eine große Anzahl von Dokumenten gespeichert, die in das DMS geladen werden mussten, ohne Informationen über ihre Kategorisierung zu verlieren.',
              },
              7: {
                title: 'Daten zur Information',
                description: 'Die Nutzer hatten keine einfache Möglichkeit, eine Antwort auf eine einfache Frage zu erhalten: Wie viele Standorte gibt es, an denen für 2020 keine elektrische Inspektion durchgeführt wird?',
              },
            },
          },
          solution: {
            description: 'Bei OBJECTIFY haben wir ein webbasiertes DMS-System entwickelt, das nicht um Ordner herum organisiert ist, sondern stattdessen die Definition benutzerdefinierter Felder für Dokumente ermöglicht, die zum Speichern verschiedener Metadaten sowie zur Suche verwendet werden können.',
            list: {
              1: {
                title: 'Dokumentenorganisation und strukturierte Daten',
                description: 'Die Verwendung von Ordnern zur Kategorisierung von Dokumenten hat einige erhebliche Nachteile: Benutzer müssen sich auf eine einzige Ordnerhierarchie einigen und Dokumente entsprechend zuweisen. Darüber hinaus geben Ordner keine Informationen über die darin enthaltenen Daten. Aus diesem Grund haben wir uns entschieden, überhaupt keine Ordner zu verwenden. In DMS werden alle strukturierten Informationen (Projekt, Erstellungsdatum, Dokumenttyp, was immer Sie möchten) in einem bestimmten Dokumentattribut gespeichert, das erweiterte Filterung, Berichterstellung zu Dokumenten, Validierungen, Berechtigungsregeln basierend auf Attributwerten und mehr ermöglicht.',
              },
              2: {
                title: 'Verhinderung von Duplikaten und falschen Kategorisierungen',
                description: 'Benutzer können Dokumenttypen und ihre Attribute definieren. Sie können auch anpassen, welche Felder obligatorisch sind. Um zu verhindern, dass Benutzer Inhalte duplizieren, haben wir eine Suche implementiert, die Ähnlichkeiten im Inhalt erkennt und den Benutzer über gefundene Ergebnisse benachrichtigt. Darüber hinaus können Benutzer „Upload-Bäume“ definieren, um verschiedene Dokumenttypen für ein bestimmtes Szenario einfach hochzuladen. Benutzer können auch Regeln konfigurieren, um strukturierte Informationen aus hochgeladenen Ordnern einzuschließen.',
              },
              3: {
                title: 'Suche',
                description: 'Wir verwenden Apache Solr für die Indexierung von Dokumenten und die Volltextsuche mit Hervorhebung des Wortvorkommens, Funktionen zur automatischen Vervollständigung oder Rechtschreibkorrekturen. Wir haben außerdem eine Facettensuche implementiert, damit Benutzer die Ergebnisse der Volltextsuche einfach eingrenzen können. Die Facettensuche ermöglicht auch eine hierarchieunabhängige Suchreihenfolge; „Ortsorientierte“ Benutzer können zunächst nach Standort filtern, „zeitorientierte“ Benutzer filtern nach Zeitbereich.',
              },
              4: {
                title: 'Sicherheit und Rückverfolgbarkeit',
                description: 'Wir haben einen Sicherheitsmechanismus für DMS implementiert, der bis auf die Ebene einzelner Dokumente fein abgestimmt werden kann. Benutzer können Zugriffsrechte für jedes Dokument einzeln festlegen oder Regeln basierend auf Dokumentfeldwerten konfigurieren. Darüber hinaus führen wir ein detailliertes Aktivitätsprotokoll für jedes Dokument, sodass keine Benutzeraktion verloren geht.',
              },
              5: {
                title: 'Datenimport',
                description: 'Um Daten zu DMS migrieren zu können, haben wir ein eigenständiges Migrationstool mit einer konfigurierbaren Regel-Engine implementiert, das nicht nur Dokumente migriert, sondern auch Dokumente aus verschiedenen Datenquellen (gemeinsames Laufwerk, Sharepoint, Datenbank usw.) synchronisieren kann. Auf diese Weise kann DMS nicht nur als Dokumentenspeicher, sondern auch als Suchmaschine für andere Anwendungen verwendet werden.',
              },
              6: {
                title: 'Dateninformationen',
                description: 'Da alle strukturierten Daten in dedizierten Feldern gespeichert sind, konnten wir eine Berichts-Engine erstellen, mit der Benutzer tabellarische Berichte erstellen können, um den Fortschritt von Installationen, Dokumentstatistiken und vieles mehr zu verfolgen.',
              },
            },
          },
        },
        dodes: {
          title: 'Dodes',
          description: 'Dodes ist die Abkürzung für Diagnostic Nodes (Diagnostische Knoten). Es handelt sich dabei um eine Methode, die von Prof. Dr. Paul Martin Putora vom St. Gallen-Krankenhaus in der Schweiz entwickelt wurde.',
          problem_definition: 'Eine medizinische Leitlinie ist ein Dokument, das als Leitfaden für Entscheidungen und Kriterien hinsichtlich Diagnose, Management und Behandlung in bestimmten Bereichen der Gesundheitsversorgung dienen soll. Diese Leitlinien werden regelmäßig aktualisiert und liegen häufig in Form von „Freitext“-Dokumenten vor.<br /> <br />Der Gesundheitsdienstleister ist verpflichtet, die medizinischen Leitlinien seines Berufsstandes zu kennen und muss entscheiden, ob er den Empfehlungen der Leitlinie für die individuelle Behandlung folgt. Es gilt, einen Weg zu finden, die neuesten Leitlinien bekannt zu machen und auf mögliche Abweichungen zwischen den Leitlinien und der gängigen Praxis aufmerksam zu machen.<br /> <br />Professor Dr. Paul Martin Putora schlug eine Methode zur strukturierten Dokumentation des Entscheidungsprozesses vor. Er verwendete eine Entscheidungsbaumnotation, die die Informationen auf sehr effiziente und lesbare Weise verdichtete und es außerdem ermöglichte, den Entscheidungsprozess zwischen verschiedenen Gesundheitsdienstleistern zu vergleichen.',
          challenge: {
            list: {
              1: {
                title: 'Vereinheitlichung der Terminologie',
                description: 'Behandlungsentscheidungen basieren auf Parametern, die in verschiedenen Krankenhäusern unterschiedliche Namen haben können. Obwohl verschiedene Krankenhäuser dieselben Namen für dieselben Parameter verwenden, können sie Parameterwerte in unterschiedlichen Einheiten ausdrücken; Beispielsweise kann Glukose sowohl in mmol/L als auch in mg/dL gemessen werden. Um Berechnungen durchführen zu können, war es notwendig, diese Terminologie zu vereinheitlichen oder zumindest abzubilden.',
              },
              2: {
                title: 'Vergleich von Entscheidungsbäumen',
                description: 'Entscheidungsbäume können auf verschiedene Weise dokumentiert werden. Einige bevorzugen die Verwendung komplexer mathematischer Ausdrücke, um zu definieren, wann eine bestimmte Aktion ausgeführt wird, während andere einfache logische Ausdrücke verwenden. Einige medizinische Zentren können bestimmte Parameter weglassen, da die Messungen für diesen Parameter nicht durchgeführt wurden. Unterschiede in solch komplizierten Strukturen zu finden, war nicht trivial.',
              },
              3: {
                title: 'Riesiger Zustandsraum',
                description: 'Der Entscheidungsvergleich wurde in Studien durchgeführt, an denen mehr als 10 Krankenhäuser teilnahmen. Eine Behandlung kann von mehr als 10 Parametern abhängen. Um einen solchen Zustandsraum auszuwerten, können wir leicht Milliarden von Kombinationen erhalten, die ausgewertet werden müssen.',
              },
              4: {
                title: 'Datenpräsentation',
                description: 'Die Unterschiede zwischen den Behandlungen können ziemlich groß sein. Es ist schwierig, aus den Ergebnissen die richtigen Erkenntnisse zu gewinnen, wenn die Benutzer die Ergebnisse nicht im Detail untersuchen.',
              },
            },
          },
          solution: {
            list: {
              1: {
                title: 'Vereinheitlichung der Terminologie',
                description: 'Bevor ein Entscheidungsbaum für eine bestimmte Behandlung erstellt werden kann, muss die Terminologie in der Behandlungsvorlage vereinheitlicht werden. Diese Vorlage definiert ein Vokabular für Entscheidungsbäume in Bezug auf die Parameter, die bei der Behandlung berücksichtigt werden müssen, sowie die Maßnahmen, die ergriffen werden können. Wenn ein Benutzer einen Entscheidungsbaum erstellt, verwendet das System eine Vorlage, um Orientierung zu geben und den Eingabeprozess zu erleichtern.',
              },
              2: {
                title: 'Vergleich von Entscheidungsbäumen',
                description: 'Wir haben Algorithmen implementiert, die einen Entscheidungsbaum in einen mehrdimensionalen Zustandsraum umwandeln und jeder „Koordinate“ eine Reihe von Aktionen für einen bestimmten Parameterbereich zuweisen können. Dadurch können wir jede Koordinate vergleichen und die Unterschiede feststellen. Aus diesen Informationen können wir im Nachhinein einen Entscheidungsbaum generieren, der die Ergebnisse des Vergleichs darstellt. Wir können denselben Ansatz verwenden, um die Validierung von Entscheidungsbäumen zu verbessern, beispielsweise durch die Berechnung von Parameterbereichen, die keine Aktion oder widersprüchliche Bedingungen haben.',
              },
              3: {
                title: 'Riesiger Zustandsraum',
                description: 'Um große Entscheidungsbäume aus vielen Institutionen zu berechnen, haben wir eine parallelisierte Berechnung mithilfe der Google-Aufgabenwarteschlange implementiert. Der rechnerische Zustandsraum wird in viele kleinere Räume aufgeteilt, die an die Aufgabenwarteschlange gesendet werden. Dieser Dienst umfasst so viele Computer wie nötig und führt die Berechnung parallel durch. Er gibt Ergebnisse zurück, die zu einem einzigen Vergleichsergebnis zusammengeführt werden. Auf diese Weise können wir Vergleichsberechnungen nahezu in Echtzeit durchführen.',
              },
              4: {
                title: 'Datenpräsentation',
                description: 'Um die Vergleichsergebnisse zu reduzieren, können Benutzer Aktions- oder Parameterwertfilter verwenden und so den Zustandsraum auf viel kleinere Größen reduzieren. Wir suchen noch nach Möglichkeiten, das Vergleichsergebnis kompakter und lesbarer zu gestalten. Wir experimentieren derzeit mit der Verwendung von Korrelationsmatrizen.',
              },
            },
          },
        },
        koderia: {
          title: 'Koderia',
          description: 'Koderia ist ein Online-Portal für Entwickler und Studenten mit Schwerpunkt Software-Engineering. Das Portal bietet Brancheninformationen, darunter Artikel, Veranstaltungen, Stellenangebote und Originalinhalte – Blogs. Es bietet auch zusätzliche Unterstützung wie Gehaltsrechner, angemessenes Gehalt, technisches Wörterbuch usw.',
          challenge: {
            description: 'Viele Unternehmen bieten Softwareentwicklern offene Stellen an. Wir mussten uns abheben und ein Produkt schaffen, das einzigartig ist. Gleichzeitig war es wichtig, Vertrauen zwischen dem Unternehmen und den Entwicklern aufzubauen.',
            list: {
              1: {
                title: 'Unser Ziel',
                description: 'Das Hauptziel von Koderia (früher als „Entwickler für Entwickler“ bekannt) war es, die Anzahl der E-Mail-Abonnenten für unsere offenen Stellen bei Objectify zu erhöhen.',
              },
            },
            post_list_description: {
              header_1: 'Der Beginn des multifunktionalen Portals',
              text_1: 'Es begann als einfache Website mit einem einfachen Formular, in dem Entwickler herausfinden konnten, wie viel sie verdienen sollten (Gehaltsrechner). Da wir die wirtschaftliche Lage der Branche gut kannten, konnten wir persönlich, schnell und sachgerecht antworten. Die Kampagne erfreute sich bei Entwicklern großer Beliebtheit und brachte Hunderte neuer Kontakte. Da haben wir beschlossen, einen Online-Bereich zu schaffen, der alle wichtigen Informationen über die Branche an einem Ort vereint.',
              header_2: 'Umstellung auf Vue und Firestore',
              text_2: 'Als Koderia wuchs, wurde klar, dass WordPress einfach nicht ausreichen würde.',
              text_3: 'Die Entscheidung für Firebase erwies sich als vorteilhaft. Firebase bot uns viele sofort einsatzbereite, anpassbare Funktionen wie:',
              list: {
                1: 'Die Echtzeitdatenbank wurde verwendet, bis umfassendere Abfragefunktionen erforderlich waren, während Firestore alles bereitstellt, was wir seitdem benötigt haben und wahrscheinlich jemals für das Koderia-Projekt benötigen werden.',
                2: 'Cloud Functions hat sich als passender Ersatz für ein Standard-Backend erwiesen.',
                3: 'Die Firebase-Authentifizierung war eine nette Funktion, die sich nutzen und implementieren ließ. Anbieter wie Google, Facebook, Github (und auch Standard-E-Mail + Passwort) wurden problemlos implementiert.',
                4: 'Firebase CI/CD bot uns außerdem eine benutzerfreundliche Bereitstellungslösung, die wir seit unserer ersten Veröffentlichung eingerichtet und verwendet haben.',
              },
              text_4: 'Diagramme, Visualisierungen und vieles mehr finden Sie jetzt bei Koderia. Wir danken chart.js sehr. Die Integration dieser Bibliothek zusammen mit vielen anderen externen und benutzerdefinierten Bibliotheken verlief problemlos.',
            },
          },
          solution: {
            list: {
              1: {
                title: 'Koderia Lebenslauf',
                description: 'Die fortschrittlichste Funktion von Koderia ist ein einzigartiger Lebenslauf, der für Softwareentwickler entwickelt wurde. Das Design des Lebenslaufs ist an die Softwarebranche angepasst und hilft, Informationen einfacher und übersichtlicher zu kommunizieren als die meisten anderen verfügbaren Lebenslaufdienste. Entwickler können sich dann auf offene Stellen bei Koderia oder anderswo bewerben. Bei der Entwicklung dieser Funktion waren unsere Hauptaspekte des Produkts:',
                cards: {
                  1: {
                    title: 'Reaktionsfähigkeit',
                    description: 'Der Lebenslauf musste sowohl auf allen Geräten als auch in gedruckter Form gut lesbar sein',
                  },
                  2: {
                    title: 'Sprachauswahl',
                    description: 'Benutzer müssen Sprachen auswählen können',
                  },
                  3: {
                    title: 'Sicherheit',
                    description: 'Für mehr Privatsphäre können Benutzer ihre Lebensläufe in den privaten Modus schalten',
                  },
                },
              },
              2: {
                title: 'Gehaltsrechner',
                description: {
                  text_1: 'Mit dem Gehaltsrechner können Benutzer ihr Einkommen basierend auf der Art ihrer Beschäftigung berechnen. Die Funktion bietet eine umfassende visuelle Darstellung aller Ausgaben und Steuern. Das Hauptziel besteht darin, zu informieren und zu erklären, welche Art von Beschäftigung in ihrer Situation besser ist. Viele slowakische Unternehmen, insbesondere in der IT-Branche, bieten Vertrags- statt Festanstellungen an. Da das Gehalt in diesen Fällen variiert, wird der Benutzer über alle Unterschiede informiert.',
                  text_2: 'Um mehr zu erfahren, besuchen Sie',
                  a_tag: 'Koderia Gehaltsrechner',
                },
              },
              3: {
                title: 'Originalinhalt',
                description: {
                  text_1: 'Koderia schafft einen Ort, an dem Benutzer immer neue und aktuelle Informationen rund um die Softwarebranche finden können. Dieser besteht aus Abschnitten, die dynamische Inhalte bereitstellen:',
                  text_2: 'Koderia hat die erste Funktion beibehalten – die Berechnung des angemessenen Gehalts, die jetzt auch in den Lebenslauf integriert ist. Es ist nicht erforderlich, ein weiteres Formular auszufüllen. Wenn der Lebenslauf erstellt wird, wird auch das angemessene Gehalt berechnet.',
                  text_3: 'In der Zeit, in der das Projekt online ist, hat sich Koderia in der Slowakei etabliert und plant, die Unterstützung für Entwickler fortzusetzen, neue Funktionen einzuführen und bestehende zu verbessern.',
                },
                cards: {
                  1: {
                    title: 'Beiträge',
                    description: 'Artikel und Videos von Drittanbietern, sorgfältig von uns ausgewählt',
                  },
                  2: {
                    title: 'Events',
                    description: 'Ein Ort für alle Offline- und Online-IT-Events in der Slowakei',
                  },
                  3: {
                    title: 'Blogs',
                    description: 'Ein Raum für unsere Gedanken und für jeden, der seine Ideen mit unserem Publikum teilen möchte',
                  },
                  4: {
                    title: 'Jobs',
                    description: 'Unsere Hauptinhalte ermöglichen es Benutzern, ihre zukünftige Karriere in der IT-Branche zu finden',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}

export default de
